const locale = {
  accessInOut: "Entrada/Saída",
  addValidAttributeAndOptions: "Adicione um atributo e opções válidos",
  allDay: "O dia todo",
  allDays: "Todos os dias",
  allItems: "Todos os itens",
  allPaymentTypes: "Todos os tipos de pagamento",
  apiInformation: "Informações da API",
  avgAmount: "Valor médio",
  aWholeProductIsFinished:
    "Um produto completo é um produto acabado a ser vendido em seu local. Com as variantes, você pode optar por vender diferentes variações deste produto, como sabor, cor e tamanho. Todos os produtos inteiros e suas variantes teriam cada um seu próprio item de suprimento.",
  accessToken: "Token de Acesso",
  accommodation: "Acomodação",
  account: "Conta",
  accountAlreadyExists: "Este e-mail já está associado a uma conta neste local",
  accountCantSeemToFind:
    "Oh não! Não conseguimos encontrar sua conta. Entre em contato com o gerente do local para obter assistência.",
  accountCode: "Código de Conta",
  accountCodeAddedName: "Código de Conta “{0}“ adicionado.",
  accountCodeAlreadyExist: "O código da conta já existe.",
  accountEmailAdded: "Conta “{0}“ adicionada.",
  accountEmailRemoved: "Conta “{0}“ removida.",
  accountIsActive: "Conta está Ativa",
  accountMapping: "Mapeamento de Conta",
  accountMappingDescription: "Defina e mapeie suas contas para o sistema SoCashlessVENUE.",
  accountName: "Nome da Conta",
  accountNotFound: "Conta não encontrada",
  accountSettings: "Configurações da Conta",
  accountType: "Tipo de Conta",
  accountingSoftware: "Software de Contabilidade",
  accounts: "Contas",
  accrNo: "Conta ref#:",
  actions: "Ações",
  activateInPos: "Ativar no PDV",
  activateOnPos: "Ativar no Ponto de Venda (PDV)",
  activateVariant: "Ativar Variante",
  active: "Ativo",
  activeDateRange: "Intervalo de Datas Ativo",
  actualClosingBalance: "Saldo de Fechamento Real",
  actualQty: "Qtd Real",
  actualStockQty: "Quantidade Real de Inventário",
  add: "Adicionar",
  addANote: "Adicionar nota...",
  addAValidAttributeAndOptions: "Adicione um atributo e opções válidos.",
  addAWholeProduct: "Adicionar um Produto Inteiro",
  addAccount: "Adicionar Conta",
  addAnotherAccount: "Adicionar outra conta",
  addAnotherAttribute: "Adicionar Outro Atributo",
  addAnotherProductOrSupplyItem: "Adicionar outro produto ou item de suprimento",
  addAnotherSupplyItem: "Adicionar outro item de suprimento",
  addCustomQuestion: "Adicionar Pergunta Personalizada",
  addNewAccount: "Adicionar nova conta",
  addNewAccountCode: "Executar Fim do dia",
  addNewAccountCodeName: "Adicionar novo código de conta “{0}”",
  addNewPaymentMethod: "Adicionar Novo Método de Pagamento",
  addNewSupplyItem: "Adicionar Novo Item de Suprimento",
  addNewSupplyItemSelect: "Adicionar Novo Item de Suprimento “{0}”",
  addNewTax: "Adicionar Novo Imposto",
  addNote: "Adicionar Nota",
  addOption: "Adicionar Opção",
  addPaymentMethod: "Adicionar Método de Pagamento",
  addProduct: "Adicionar Produto",
  addProducts: "Adicione produtos ou itens de suprimento neste conjunto de produtos.",
  addThisProduct: "Adicione este produto como um novo produto e item de suprimento.",
  addVariant: "Adicionar Variante",
  addedStock: "Inventário Adicionado",
  adjustQuantity: "Ajustar Quantidade",
  adjustTheSupplyItemsVariant:
    "Ajuste os itens de suprimento e as quantidades para esta variante específica.",
  all: "Tudo",
  allAccountTypes: "Todos os Tipos de Conta",
  allCategories: "Todas as Categorias",
  allDevices: "Todos os Dispositivos",
  allDevicesUsed: "Todos os Dispositivos Usados",
  allDiscounts: "Todos os Descontos",
  allGuestProfiles: "Todos os Perfis de Convidados",
  allLocation: "Todos os Pontos de venda",
  allLocations: "Todos os Pontos de venda",
  allMeasurements: "Todas as Medidas",
  allPaymentMethods: "Todos os Métodos de Pagamento",
  allProducts: "Todos os Produtos",
  allReportsReadyForDownload: "Todos os relatórios prontos para download",
  allRightsReserved: "Todos os direitos reservados.",
  allRoles: "Todas as Funções",
  allSafeToDeleteLocation: "Tudo seguro! Não há produtos com este local.",
  allSelectedAvailablePos: "Todos os produtos selecionados estarão disponíveis no PDV.",
  allSelectedNotPos: "Todos os produtos selecionados não serão exibidos em seu PDV.",
  allShiftsClosed: "Todos os Turnos Fechados",
  allStaff: "Todos os Funcionários",
  allStatus: "Todos os Status",
  allExternalPayments: "Todos",
  allStockLevels: "Todos os Níveis de Inventário",
  allTransactions: "Todas as Transacções",
  allVoucherTypes: "Todos os Tipos de Voucher",
  allVouchers: "Todos os Vouchers",
  allowAccess: "Permitir Acesso",
  allowAccessAndConnect: "Permitir Acesso e Conexão",
  allowGuestWBKeeping: "Permitir que os convidados mantenham suas tags no check-out.",
  allowOrRestrictGuestWBKeeping:
    "Permitir ou restringir convidados de manter suas tags no check-out.",
  allowPostpaidAndLimit: "Permitir Créditos Pós-Pagos e definir limite",
  allowPostpaidInGuestProfile:
    "Permitir que este perfil de convidado faça compras sem créditos. Eles serão cobrados quando fizerem o check-out ndo local.",
  allowThisGuestProfileLimit:
    "Permitir que este perfil de convidado faça compras sem créditos. Eles serão cobrados quando fizerem o check-out ndo local.",
  allowedPaymentMethod: "Métodos de Pagamento Permitidos",
  almostThere: "Quase lá!",
  alreadyExists: "Já existe.",
  amount: "Quantidade",
  and: "e",
  andWouldBe: "e seria",
  anyMoreQuestions: "Mais alguma pergunta? {0}",
  applyFilter: "Aplicar Filtro",
  areYouSureYouWantToDeleteLocation:
    "Tem certeza que deseja excluir {0}? Atualmente, este local tem um valor de inventário de {1}.",
  areYouSureYouWantToDeleteProduct:
    "Tem certeza que deseja excluir {0}? Este item de suprimento possui atualmente {1} {2} em inventário.",
  areYouSureYouWantToDeleteProduct2:
    "Tem certeza que deseja excluir {0}? Ele não estará mais disponível em seu local. As transações e relatórios anteriores não serão afetados.",
  areYouSureYouWantToRemoveVariant:
    "Tem certeza de que deseja remover a variante “{0}”? Seu item de suprimento não seria removido.",
  arrivalDate: "Data de Chegada",
  arrivals: "Chegadas",
  askDeleteGuestProfile: "Excluir perfil de convidado?",
  askDeleteStaffProfile: "Excluir perfil de funcionários?",
  askGuestInfoCheckIn: "Peça informações dos convidados durante o check-in.",
  assemble: "Montar",
  assembleAProduct: "Montar um produto",
  asset: "Recurso",
  assignAProfile: "Atribuir um perfil",
  assignFreeCreditsStaff: "Atribuir créditos grátis para funcionários neste grupo",
  assignVoucherStaff: "Atribuir os vouchers aos funcionários deste grupo",
  assignVoucherToGuest: "Atribuir os vouchers aos convidados deste grupo no momento do registro.",
  assignedRooms: "Quartos/Camas Atribuídos",
  assignedSpace: "Espaço Atribuído",
  attribute: "Atributo",
  attributeAlreadyExists: "O nome do atributo já existe neste produto",
  automaticallyGenerateSku: "Gerar SKU automaticamente",
  availability: "Disponibilidade",
  availabilityOnPos: "Disponibilidade no PDV",
  availableAnytime: "Disponível a qualquer hora",
  availableEveryday: "Disponível todos os dias",
  availableOnPos: "Disponível no Ponto de Venda (POS)",
  averageAmountPerItem: "Méd. Quantidade por Item",
  averageDurationOfStay: "Duração Média da Estadia",
  averageOrderValue: "Valor Médio do Pedido",
  awaitingInviteResponse: "Aguardando resposta ao convite.",
  back: "Voltar",
  banATag: "Banir uma Tag",
  blockATag: "Banir uma Tag",
  banDetails: "Detalhes da Proibição",
  banList: "Lista de Banimento",
  blockedTags: "Tags Banidas",
  banTag: "Banir Tag",
  banTagListSettings: "Configurações da List de Tags Proibidas",
  banTags: "Banir Tags",
  bannedBy: "Banida Por",
  blockedBy: "Banida Por",
  bannedTags: "Tags Banidas",
  banningThisTagWillOnlyTakeEffect:
    "Banir esta tag só terá efeito na próxima vez que seus dispositivos forem sincronizados e atualizados (geralmente a cada 5 minutos quando conectado à Internet). Para refletir essas mudanças imediatamente, sincronize e atualize seus dispositivos assim que banir esta tag.",
  basicInfo: "Informação Básica",
  belowParLevel: "Abaixo do Nível Ideal",
  billAmount: "Valor da Conta",
  birthdate: "Data de Nascimento",
  birthday: "Aniversário",
  bookedBy: "Reservado por",
  bookingAmount: "Valor da Reserva",
  bookingDescription: "Acompanhe todas as reservas em seu local.",
  bookingDetails: "Detalhes da Reserva",
  bookingId: "ID da Reserva",
  bookingList: "Lista de Reservas",
  bookingNo: "Núm. Reserva",
  bookingSummary: "Sumário da Reserva",
  bookings: "Reservas",
  bottle: "garrafa",
  browseProducts: "Procurar Produtos",
  browseVouchers: "Procurar Vouchers",
  businessAddress: "Endereço Profissional",
  businessContactNumber: "Número de Contato Comercial",
  businessDay: "Dia Útil",
  businessName: "Nome da Empresa",
  byAssemblingAProduct:
    "Ao montar um produto, você pode criar um produto com vários itens de suprimento, bem como decompor um único item de suprimento com variantes.",
  byCategory: "Por categoria",
  byCreatingPrinterProfiles:
    "Ao criar perfis de impressora, você pode definir quais produtos imprimir em notas de pedidos para as diferentes estações de seu local, como cozinhas, bares, etc.",
  byGuest: "Por hóspede",
  byItem: "Por item",
  byLocation: "Por localização",
  byStaff: "Por funcionário",
  cancel: "Cancelar",
  cancelBanTag: "Cancelar Proibição de Tag",
  cancelled: "Cancelado",
  cannotBeDeleted: "Não pode ser excluído",
  cannotDeletePartOfComposite: "{0} não pode ser excluído porque faz parte de {1} composto {2}.",
  cantFindDesc:
    "Não consegue encontrar o que está procurando? Tente uma pesquisa ou filtro diferente.",
  capacity: "Capacidade",
  card: "Cartão",
  cash: "Dinheiro",
  categories: "Categorias",
  categoriesDeleted: "{0} categorias excluídas",
  categorizeAndManage: "Categorize e gerencie todas as transações com plano de contas.",
  category: "Categoria",
  categoryCreated: 'Categoria "{0}" criada.',
  categoryDeleted: 'Categoria "{0}" excluída.',
  categoryList: "Lista de Categorias",
  categoryName: "Nome da Categoria",
  categoryNameAlreadyExist: "O nome da categoria já existe.",
  categoryReport: "Relatório de Categoria",
  categoryUpdated: 'Categoria "{0}" atualizada.',
  change: "Mudar",
  changePassword: "Mudar Senha",
  changePhoto: "Mudar Foto",
  changeRevenueAccount: "Alterar conta de receita",
  changesSaved: "Alterações salvas.",
  changingCurrencyWontAffect:
    "Alterar a moeda não afetará o valor do preço de seus produtos, apenas seus símbolos de moeda.",
  chargeTaxesOnThisProduct: "Cobrar impostos sobre este produto",
  chartOfAccounts: "Plano de Contas",
  chartOfAccountsDescription: "Atualize e gerencie seu plano de contas.",
  checkInDate: "Data de Check-in",
  checkInDetails: "Detalhes do Check-in",
  checkInQuestions: "Perguntas de Check-in",
  checkInSettings: "Configurações de Check-in",
  checkIns: "Check-ins",
  checkoutCreditsReturned: "Créditos devolvidos no checkout",
  checkOutDetails: "Detalhes de Check-out",
  checkoutPaymentCollected: "Pagamento recebido no checkout",
  checkOutTheGuide: "Confira o guia para conectar integrações.",
  checkOuts: "Check-outs",
  checkStocks: "Verificar Inventários",
  checkYourEmail: "Verifique seu e-mail",
  checkYourEmailAt: "Verifique seu e-mail em {0} para concluir a configuração da sua conta.",
  checkYourEmailOrAdmin: "Verifique seu e-mail ou entre em contato com o administrador.",
  checkbox: "Caixa de Seleção",
  checkedIn: "Check-in realizado",
  checkedInBy: "Check-in realizado por",
  checkedInDate: "Data de Check-in",
  checkedOut: "Check-out realizado",
  checkedOutBy: "Check-out realizado por",
  checkedOutDate: "Data de Check-Out",
  checkedOutOn: "Check-out realizado em",
  checkinId: "ID de Check-in",
  checkingYourInternet: "Verificando sua conectividade de Internet ou dados.",
  checkout: "Check-out",
  chooseAPassword: "Use uma senha forte que você não usa em nenhum outro lugar.",
  chooseAReason: "Escolha um motivo",
  chooseASimpleOrMultipleItem: "Escolha um ou vários itens de suprimento para criar um produto.",
  chooseAVenue: "Escolha um local",
  chooseAtleast1Location: "Escolha pelo menos 1 local",
  chooseCategoryColor: "Escolha uma cor de categoria",
  chooseColumns: "Escolha quais colunas você gostaria de ver neste relatório.",
  chooseInformation: "Escolha quais informações incluir no detalhamento de vendas.",
  chooseLocationForThisStaff: "Escolha a designação de local para este funcionário",
  choosePassword: "Escolha a senha",
  choosePaymentMethod: "Escolher Método de Pagamento",
  chooseProductsCanBeDiscounted:
    "Escolha quais produtos de seu inventário podem receber descontos.",
  chooseRole: "Escolha as funções para este funcionário",
  chooseTheLocationWhereThisProduct:
    "Escolha os locais onde este produto é vendido e onde os suprimentos são deduzidos.",
  chooseVouchers: "Escolha os Vouchers",
  cityStateCountry: "Cidade, Estado, País, Código Postal",
  clear: "Limpar",
  clearAllFilters: "Limpar todos os filtros",
  clearDownloads: "Limpar Downloads",
  clearedTags: "Tags Apagadas",
  clearedUnusedAndExpiredCredits: "Créditos Liberados, Não Usados e Expirados",
  clearedUnusedAndExpiredCreditsMessage:
    "Para créditos que foram carregados, mas foram compensados, não reembolsáveis ou expirados.",
  clearedUnusedAndExpiredCreditsPlaceholder: "[xxxx] - Outras Receitas (expiração)",
  clearedUnusedExpiredCredit: "Outras Receitas (expiração)",
  clickHereToRetry: "Clique aqui para tentar novamente.",
  closePreview: "Fechar Preview",
  closeReceiptPreview: "Fechar Visualização do Recibo",
  cloudbedsDescription: "Gestão hoteleira que mantém sua recepção e os dados dos hóspedes em um só lugar.",
  cloudbedsPropertyName: "Nome da propriedade no Cloudbeds",
  code: "Código",
  coffeeBeans: "grãos de café",
  columns: "Colunas",
  combineYourProducts: "Combine seus produtos para serem vendidos como um conjunto.",
  communityGuidelines: "diretrizes da comunidade",
  companyDetails: "Detalhes da Companhia",
  completeStocktake: "Verificação de Inventário Finalizada",
  completeStocktakeConfirmation: "Finalizar {0}?",
  completeSubscription: "Assinatura Completa",
  completeThisIntegrationByAssigning: "Conclua esta integração atribuindo pontos de venda/serviços nas configurações abaixo.",
  completeThisIntegrationByAssigningShort: "Conclua esta integração atribuindo pontos de venda/serviços nas suas configurações.",
  completeYourSubscription: "Conclua sua inscrição para acessar seu local",
  completed: "Finalizado",
  completedBy: "Finalizado por",
  completedOn: "Finalizado em",
  composite: "Composto",
  composition: "Composição",
  compositionGuide: "Guia de Composição",
  confirmPassword: "Confirmar a senha",
  confirmed: "Confirmado",
  connectAndInstall: "Conecte e Instale",
  contactUsAction: "Fale conosco",
  coordinates: "Coordenadas",
  costOfGoods: "Custo dos produtos",
  creditExpirationOnCheckout: "Expiração de créditos no check-out",
  creditFlow: "Fluxo de créditos",
  creditStatus: "Status do crédito",
  creditsKeptOutlet: "Ponto de venda de créditos retidos",
  creditsReceivedOutlet: "Ponto de venda de créditos recebidos",
  customIntegrations: "Integrações personalizadas",
  denominationGroupDescription: "Este grupo de denominações serão as opções disponíveis na tela de recarga do aplicativo do seu estabelecimento.",
  detailedAccessControl: "Controle de acesso detalhado",
  duplication: "Duplicação",
  eatAppDescription: "Reservas, gestão de mesas e perfis de hóspedes para salões movimentados.",
  eatAppId: "ID do Eat App",
  editOutletsAndService: "Editar pontos de venda e serviço",
  editRevenueAccount: "Editar conta de receita",
  enterEatAppRoomId: "Insira o ID da sala do Eat App",
  enterEatAppRoomIdToMap: "Insira o ID da sala do Eat App para vincular a este perfil de hóspede.",
  erpAndAccounting: "ERP e contabilidade",
  errorProcessingProductData: "Erro ao processar os dados do produto. Tente novamente.",
  eventEndDate: "Data de término do evento",
  eventId: "ID do evento",
  eventName: "Nome do evento",
  eventStartDate: "Data de início do evento",
  exportFailed: "Falha na exportação",
  externalTicketId: "ID do ticket externo",
  finishIntegration: "Concluir integração",
  firmware: "Firmware",
  fixed: "Fixo",
  friday: "Sexta-feira",
  fromThisArticle: "deste artigo",
  fullLabel: "Completo",
  grossMargin: "Margem bruta",
  hereAreSomeTroubleshootingSteps: "Veja algumas etapas de solução de problemas.",
  howToFindYourAccessToken: "Como encontrar seu token de acesso",
  imei: "IMEI",
  lastLocation: "Última localização",
  lastSeen: "Visto pela última vez",
  linkedService: "Serviço vinculado",
  lobbyDescription: "Software para hotéis, hostels, glampings e pousadas.",
  mapLoadingError: "Erro ao carregar o mapa",
  mappingGuestProfileWithEatApp: "Vinculação do perfil de hóspede com o Eat App",
  maxAmount: "Valor máximo",
  mewsAccountingIntegrationRequirements: "Requisitos da integração do MEWS Accounting",
  mewsDashboard: "Painel do MEWS",
  mewsDescription: "Simplifica e automatiza as operações diárias para hoteleiros modernos.",
  mewsDisconnectionMessage: "Tem certeza de que deseja desconectar do Mews? Esta integração e todas as informações do Mews serão removidas do seu estabelecimento.",
  mewsInstructionStep1: "1. Acesse seu",
  mewsInstructionStep2: "2. Acesse Menu principal > Marketplace.",
  mewsInstructionStep3: "3. Pesquise “SoCashless”, clique em “Explore” e depois em “Connect Integration”. Se o SoCashless já estiver conectado, siga para a próxima etapa.",
  mewsInstructionStep4: "4. Procure “SoCashless” em My Subscriptions e clique em Edit.",
  mewsInstructionStep5End: "no canto superior direito e copie o token de acesso.",
  mewsInstructionStep5Start: "5. Clique no ícone de chave",
  mewsOutletSyncDescription: "Todas as transações são sincronizadas com pontos de venda específicos no MEWS conforme o tipo de transação. Recomendamos criar pontos de venda novos específicos para as transações feitas pelo aplicativo. Para saber como criar pontos de venda no MEWS, siga a etapa \"Create an outlet\"",
  mewsPropertyName: "Nome da propriedade no MEWS",
  mewsServiceSyncDescription: "Todas as transações sincronizadas precisam estar vinculadas a um serviço \"Additional\" criado no MEWS. Recomendamos criar um serviço novo para associar as transações feitas pelo aplicativo. Para saber como criar um serviço adicional no MEWS, siga a etapa \"Create an additional service\"",
  mewsTroubleshootingStep1Desc: "Verifique se o status da sua integração do MEWS Accounting não é \"Parcialmente conectado\". Se esse for o status na página de integrações, significa que você ainda não configurou seus pontos de venda e serviços. Clique no botão \"Concluir integração\" para finalizar o processo.",
  mewsTroubleshootingStep1Title: "Etapa n.º 1: Configure seus pontos de venda e serviços",
  mewsTroubleshootingStep2DescEnd: "mostra as etapas de como fazer isso.",
  mewsTroubleshootingStep2DescStart: "Como o aplicativo funciona de forma híbrida (offline e online), precisamos garantir que suas transações ainda possam ser sincronizadas com o MEWS mesmo em caso de interrupção prolongada da rede. Por isso, recomendamos definir a \"janela de histórico editável da contabilidade\" para 7 dias nas configurações do MEWS.",
  mewsTroubleshootingStep2Title: "Etapa n.º 2: Edite a janela de histórico editável da contabilidade",
  mewsTroubleshootingStep3DescMiddle: "é a mesma configurada na sua conta MEWS",
  mewsTroubleshootingStep3DescStart: "Verifique se a moeda definida no painel do seu estabelecimento",
  mewsTroubleshootingStep3Hint1: "(você pode encontrá-la em Configurações > Geral)",
  mewsTroubleshootingStep3Hint2: "(Configurações > Propriedade > Globalização > Moeda padrão)",
  mewsTroubleshootingStep3Title: "Etapa n.º 3: Verifique suas configurações de moeda",
  mewsTroubleshootingStep4Desc: "As transações que não estiverem vinculadas a um hóspede do MEWS serão sincronizadas após a execução do procedimento de fechamento do dia. Recomendamos executar o fechamento do dia pelo menos uma vez por dia.",
  mewsTroubleshootingStep4Title: "Etapa n.º 4: Certifique-se de executar o fechamento do dia",
  mewsTroubleshootingSteps: "Etapas de solução de problemas do MEWS",
  minAmount: "Valor mínimo",
  monday: "Segunda-feira",
  needSomethingElse: "Precisa de mais alguma coisa?",
  noDataMatchesTheseFilters: "Nenhum dado corresponde a estes filtros.",
  noDevicesAvailable: "Nenhum dispositivo disponível",
  noPaymentGatewaysFound: "Nenhum gateway de pagamento encontrado",
  notAvailable: "N/D",
  noValidMapCoordinates: "Nenhuma coordenada de mapa válida encontrada para o dispositivo selecionado.",
  nttDataDescription: "Adquirência de cartões e processamento de pagamentos para transações no local.",
  nttDataPaymentGatewayEnquiry: "NTT DATA Payment Gateway enquiry",
  connected: "Conectado",
  contactNumber: "Número de Contato",
  contactUs: "contato",
  contactUs2: "Contato",
  continue: "Continuar",
  continueAs: "Continue como {0}",
  continueBanningThisTag: "Continuar banindo esta tag?",
  continuingOnThisPageWillLogout: "Continuar nesta página fará o logout de sua sessão atual.",
  copied: "Copiado!",
  copyLink: "Copiar Link",
  copyrightYear: "Copyright © 2026",
  costOfGoodsSold: "Custo das Mercadorias Vendidas (CMV)",
  costOfGoodsSoldMessage: "A conta padrão para o custo de um suprimento depois de vendido.",
  costOfGoodsSoldPlaceholder: "[xxxx] - CMV/CMV",
  country: "País",
  createALocation: "Criar um Local",
  createAccount: "Criar Conta",
  createAndManageProducts:
    "Crie e gerencie produtos que podem ser vendidos em seus pontos de venda",
  createAndManageRawMaterials:
    "Crie e gerencie itens de matéria-prima e seus inventários de inventário para cada local.",
  createAndManagerDiscounts: "Crie e gerencie seus descontos com produtos com desconto",
  createAndManagerVouchers: "Crie e gerencie seus vouchers que serão usados para resgatar produtos",
  createCategoriesToLink: "Crie categorias para vincular e categorizar seus produtos",
  createCategory: "Criar Categoria",
  createDiscountPage: "Criar Página de Desconto",
  createLocation: "Criar Local",
  createLocationToStoreYourProducts: "Crie um local para armazenar seus produtos.",
  createNewCategory: "Criar Nova Categoria",
  createNewDiscount: "Criar Novo Desconto",
  createNewGuestProfile: "Criar Novo Perfil de Convidado",
  createNewLocation: "Criar Novo Local",
  createNewProduct: "Criar Novo Produto",
  createNewProductSet: "Criar Novo Conjunto de Produtos",
  createNewProfile: "Criar Novo Perfil",
  createNewStaffProfile: "Criar Novo Perfil de Funcionário",
  createNewStocktake: "Criar Nova Verificação de Inventário",
  createNewSupplyItem: "Criar Novo Item de Suprimento",
  createNewVoucher: "Criar Novo Voucher",
  createNote: "Criar Nota",
  createPrinterProfile: "Criar Perfil de Impressora",
  createProduct: "Criar Produto",
  createProductSet: "Criar Conjunto de Produtos",
  createStaffProfile: "Criar Perfil de Funcionário",
  createStaffWhoCan:
    "Crie um funcionário que pode recarregar créditos, registrar convidados e vender em seus locais.",
  createTheProduct: "Crie os produtos para vender em seu local.",
  createVoucherPage: "Criar Página de Voucher",
  createVouchersForGuest: "Crie vouchers para seus convidados e funcionários usarem!",
  createYourOwnIntegration: "Crie suas próprias integrações com SoCashlessCONNECT",
  createYourVenue: "Criar Seu Local",
  createdSupplyItem: "Criar Item de Suprimento",
  credit: "Crédito",
  creditAutomaticallyExpires: "Os créditos expiram automaticamente após o check-out",
  creditBalance: "Saldo de Créditos",
  creditLimits: "Limites de Créditos",
  creditSettings: "Configurações de Crédito",
  credits: "Créditos",
  creditsDescription:
    "Atribua créditos grátis para convidados neste grupo e defina seu limite de crédito pós-pago.",
  creditsExpiration: "Vencimento de Créditos",
  creditsExpirationDescription:
    "Defina os créditos para expirar quando um convidado fizer check-out.",
  creditsExpirationOnCheckout: "Vencimento dos Créditos no Check-out",
  creditsLiabilityAccount: "Conta de Garantia de Créditos",
  creditsLiabilityAccountMessage:
    "A conta de reserva para todos os créditos que são carregados em uma tag antes das vendas.",
  creditsLiabilityAccountPlaceholder: "[xxxx] - Garantia/Créditos",
  creditsNeverExpires: "Os créditos nunca expiram após o check-out.",
  creditsWouldNeverExpire: "Os créditos nunca expiram quando um convidado está fazendo o check-in.",
  dashboardCreditsKept: "Créditos mantidos",
  dashboardCreditsReceived: "Créditos recebidos",
  currency: "Moeda",
  currencyAndFormat: "Moeda e Formato",
  currentGuestProfiles: "Perfis de Convidados Atuais",
  currentPassword: "Senha Atual",
  currentPasswordAndNewPasswordMatched: "A senha atual e a nova são correspondidas",
  custom: "Personalizado",
  customDateTime: "Data e Intervalo de Tempo Personalizados",
  customFields: "Campos Personalizados",
  customQuestion: "Pergunta Personalizada",
  customQuestions: "PerguntasPersonalizadas",
  customTax: "Imposto Personalizado",
  customerBehaviourOverTime: "Comportamento do Cliente Horas Extras",
  customizeReceipt: "Personalize cada seção do seu recibo.",
  customizeSectionReceipt: "Personalize as seções do seu recibo.",
  dashboard: "Painel",
  date: "Data",
  dateAndTimeOfTransaction: "Data e Hora da Transação",
  dateBanned: "Data de Banimento",
  dateBlocked: "Data de Banimento",
  dateCreated: "Data de Criação",
  dateIssuedWithColonSymbol: "Data de Emissão:",
  dateModified: "Data Modificada",
  dateOfCheckin: "Data de Check-in",
  dateOfCheckout: "Data de Check-out",
  dateOfRegistration: "Data de Registro",
  dateRange: "Intervalo de Datas",
  day: "dia",
  days: "dias",
  daysAfterCheckout: "dias após o check-out",
  debitCredit: "Cartão de Débito / Crédito",
  default: "Padrão",
  defaultAccountForTaxes: "A conta padrão para impostos cobrados para cada produto.",
  defaultFields: "Campos Padrão",
  defaultQuestions: "Perguntas Padrão",
  defaultRevenueAccount: "Conta de Receita Padrão",
  defaultRevenueAccountMessage: "A conta padrão para todas as receitas de vendas.",
  defaultTax: "Imposto Padrão",
  defectiveTag: "Tag Defeituosa",
  defectiveTags: "Tags Defeituosas",
  delete: "Excluir",
  deleteAProduct: "Excluir Produto",
  deleteAProduct2: "Excluir Produto?",
  deleteAProductSet: "Excluir Conjunto de Produtos",
  deleteCategories: "Excluir {0} categorias",
  deleteCategory: "Excluir categoria",
  deleteCurrentlyBeingUsed:
    "{0} está sendo usado em alguns conjuntos de produtos. Para continuar, remova este produto dos seguintes conjuntos de produtos",
  deleteDiscount: "Excluir Desconto",
  deleteGuestProfile: "Excluir Perfil de Convidado",
  deleteLocation: "Excluir Local",
  deleteLocationNote: "Nota: Suas transações anteriores com este local serão mantidas.",
  deleteName: 'Excluir "{0}"?',
  deleteNote: "Apagar Nota",
  deletePaymentMethod: "Excluir Método de Pagamento",
  deletePrinterProfile: "Excluir Perfil de Impressora",
  deleteProduct: "Excluir {0}?",
  deleteProductSet: "Excluir Conjunto de Produtos?",
  deleteProducts: "Excluir {0} Produtos?",
  deleteProducts2: "Excluir {0} Produtos",
  deleteQuestion: "Excluir Pergunta",
  deleteSelectedCategories: "Excluir categorias selecionadas",
  deleteSelectedCategory: "Excluir categoria selecionada",
  deleteSelectedProduct: "Excluir produto selecionado",
  deleteSelectedProducts: "Excluir produtos selecionados",
  deleteStaff: "Excluir Funcionário",
  deleteStaffProfile: "Excluir Perfil de Funcionário",
  deleteSupplyItem: "Excluir Item de Suprimento",
  deleteTax: "Excluir Imposto",
  deleteThis: "Excluir este {0}",
  deleteThisMultiple: "Excluir {0} {1}?",
  deleteThisQuestion: "Excluir esta pergunta?",
  deleteVoucher: "Excluir Voucher",
  deleted: "Excluído",
  deletedPaymentMethod: 'Método de pagamento "{0}" excluído.',
  deletedTax: 'Imposto "{0}" excluído.',
  deletingLoading: "Excluindo ...",
  deletingName: "Excluindo {0}",
  deletingThisLocation:
    "Excluir este local também removeria os saldos de inventário de todos os itens de suprimento. Essa ação não pode ser desfeita.",
  departure: "Saída",
  departureDate: "Data de saída",
  describeThisProduct: "Descreva este produto ...",
  describeThisProductSet: "Descreva este conjunto de produtos",
  description: "Descrição",
  deviceId: "ID do Dispositivo",
  deviceImei: "IMEI do Dispositivo",
  deviceImeiSerial: "IMEI / Serial do Dispositivo",
  deviceInfo: "Informação do Dispositivo",
  deviceList: "Lista des Dispositivos",
  deviceMac: "Endereço MAC do dispositivo",
  deviceMacAddress: "Endereço MAC do dispositivo",
  deviceName: "Nome do Dispositivo",
  deviceNameAlreadyExists: "Este nome de dispositivo já existe",
  deviceNameUpdated: "Dispositivo “{0}” atualizado.",
  deviceSerialNumber: "Número de Série do Dispositivo",
  devices: "Dispositivos",
  difference: "Diferença",
  disableSellingOnPos: "Desativar venda em PDV",
  discard: "Descartar",
  discardChanges: "Descartar Mudanças",
  discardWristbandKeepingSettings: "Descartar Configurações de Manutenção da Pulseira",
  disclaimerCategoryReport:
    "ISENÇÃO DE RESPONSABILIDADE: Pode haver produtos com várias categorias atribuídas a eles, o que resultará na contagem dupla em cada item de linha.",
  disconnect: "Desconectar",
  discount: "Desconto",
  discountApplied: "Desconto Aplicado",
  discountCanBeApplied: "Este desconto pode ser aplicado em seu local.",
  discountCreated: 'Desconto "{0}" criado.',
  discountDeleted: 'Desconto "{0}" excluído.',
  discountName: "Nome do Desconto",
  discountNameAlreadyExist: "Este nome de desconto já existe.",
  discountRateOrValue: "Taxa ou Valor de Desconto",
  discountReport: "Relatório de Desconto",
  discountType: "Tipo de Desconto",
  discountUpdated: 'Desconto "{0}" atualizado.',
  discountableProducts: "Produtos com Desconto",
  discounts: "Descontos",
  discountsPage: "Página de Descontos",
  discrepancy: "Discrepância",
  displayCategoryInPos: "Exibir esta categoria nos dispositivos PDV.",
  distribution: "Distribuição",
  done: "Feito",
  dontSellOnPos: "Não vender no PDV",
  dontWorry: "Não se preocupe!",
  download: "Download",
  downloading: "Fazendo download...",
  dropdown: "Suspenso",
  duplicateOption: "Opção duplicada",
  eWallet: "E-wallet",
  easierGuestReg: "Registro e Check-ins mais Fáceis de Convidados",
  eatAppId: "ID do Eat App",
  eatAppIdPlaceholder: "Insira o ID da sala do Eat App",
  eatAppMapping: "Mapeamento do Perfil de Convidado com o Eat App",
  eatAppMappingDescription: "Insira o ID da sala do Eat App para mapear com este perfil de convidado.",
  edit: "Editar",
  editAccessToken: "Editar Token de Acesso",
  editAccount: "Editar Conta",
  editCategory: "Editar Categoria",
  editDevices: "Editar Dispositivo",
  editDiscountsPage: "Editar Página de Desconto",
  editGuestProfile: "Editar Perfil de Convidado",
  editLocation: "Editar Local",
  editLocations: "Editar Pontos de venda",
  editNewCategory: "Editar Nova Categoria",
  editNote: "Editar Nota",
  editPaymentMethod: "Editar Método de Pagamento",
  editPaymentMethods: "Editar Métodos de Pagamento",
  editPrinter: "Editar Perfil de Impressora",
  editProduct: "Editar Produto",
  editProductSet: "Editar Conjunto de Produtos",
  editQuestions: "Editar Perguntas",
  editStaff: "Editar Funcionário",
  editStaffPage: "Editar Página de Funcionário",
  editStaffProfilePage: "Editar Página de Perfil de Funcionário",
  editSupplyItem: "Editar Item de Suprimento",
  editTax: "Editar Imposto",
  editVariants: "Editar Variantes",
  editVoucherPage: "Editar Página de Voucher",
  editYourAccountPreferences: "Edite suas preferências de conta, endereço de e-mail e senha.",
  egAppliesToGuests: "Por exemplo, aplica-se a convidados com 60 anos ou mais",
  egSeniorDiscount: "por exemplo, Desconto Sênior",
  egSizeFlavor: "por exemplo, Tamanho, Sabor",
  eightCharactersMinimum: "8 caracteres no mínimo",
  eitherYouHavePoorConnection:
    "Ou você tem uma conectividade de rede ruim, seu acesso foi negado ou algo deu errado do nosso lado.",
  email: "E-mail",
  emailAddress: "Endereço de E-mail",
  emailAlreadyInVenue: "Este e-mail já está associado a uma conta neste local.",
  emailDoesntHaveRecord:
    "O e-mail que você digitou não corresponde ao nosso registro, verifique e tente novamente.",
  enableSellingOnPos: "Habilitar venda no PDV",
  end: "Fim",
  endDay: "Finalizar Dia",
  endOfDay: "Fim de Dia",
  endOfDayChecklist: "Checklist de Fim de Dia",
  endOfDayReports: "Relatórios de Fim de Dia",
  enterEachOption: "Insira cada opção separada por uma vírgula",
  enterEmailToLogin: "Digite seu endereço de e-mail para fazer login.",
  enterYourEmailAddress: "Insira o seu endereço de email",
  enterYourPassword: "Coloque sua senha",
  enteredPasswordIncorrect: "A senha inserida está incorreta.",
  equity: "Patrimônio",
  errorLoadingColors: "Erro ao carregar cores. Por favor, tente novamente mais tarde.",
  example1: "Exemplo 1",
  example1AssembleProduct:
    "{0}: Um Café Latte precisaria de {1}, {2} e {3}. O inventário seria deduzido dos grãos de café, leite e açúcar quando um Café Latte é comprado.",
  example2: "Exemplo 2",
  example2AssembleProduct:
    "{0}: O vinho pode ser vendido como {1} ou {2}. Selecione o vinho como o item de suprimento, a seguir crie as variantes “garrafa” e “taça” e ajuste a quantidade do item por variante, de forma que seja deduzido do mesmo item de suprimento de forma adequada.",
  expStockQty: "Exp. Qtd em inventário",
  expectedEndingBalance: "Saldo Final Esperado",
  expectedQty: "Qtd Esperada",
  expense: "Despesa",
  expired: "Expirado",
  export: "Exportar",
  exportCheckinDetails: "Exportar Detalhes de Check-in",
  exportRegisterReport: "Exportar Relatório de Registro",
  exportTransactions: "Exportar Transações",
  exportXlsx: "Exportar como XLSX",
  extendThePower: "Amplie o poder do seu SoCashlessVENUE com os melhores add-ons.",
  failed: "Falha",
  failedToLoad: "Falha ao carregar.",
  feedback: "Feedback",
  feelFreeToContactSocashless: "Sinta-se à vontade para nos contatar em SoCashless.",
  filters: "Filtros",
  firstName: "Primeiro Nome",
  fixedAmount: "Quantia Fixa",
  fixedAmountRange: "Valor fixo deve ser entre 1-9,999,999",
  footerSection: "Seção de Rodapé",
  forApproval: "Para Aprovação",
  forceBanned: "Detalhes de Check-out Forçado e Banimento",
  forceCheckOutBy: "Check-out forçado por",
  forceCheckout: "Forçar Check-out",
  forceCheckoutDetails: "Detalhes de Check-out Forçado",
  forceCheckoutName: "Forçar Check-out {0}?",
  forcedCheckedOutBy: "Check-out forçado por",
  formatting: "Formatação",
  freeCredits: "Créditos Gratuitos",
  freeCreditsAreCreditsThatAreFreeOfCharge:
    "Créditos Gratuitos são créditos sem custos. Esses créditos são",
  freeCreditsHoverTooltip:
    "Os créditos gratuitos não são reembolsáveis e devem ser priorizados e usados primeiro no momento do pagamento.",
  freeCreditsIssued: "Créditos Gratuitos Emitidos",
  freeCreditsLiabilityAccount: "Conta de Garantia de Créditos Gratuitos",
  freeCreditsLiabilityAccountMessage:
    "Custo dos créditos gratuitos emitidos para convidados, uma vez usados.",
  freeCreditsLiabilityAccountPlaceholder: "[xxxx] - Garantia/Créditos Gratuitos",
  freeCreditsRemoved: "Créditos Gratuitos Removidos",
  freeTrial: "Teste Gratuito de 30 dias!",
  fullPay: "Pagamento Total",
  full: "Completo",
  gender: "Gênero",
  general: "Geral",
  generalSettings: "Configurações Gerais",
  generatingReport: "Gerando Relatório ...",
  getFreeCredit: "Obter crédito gratuito",
  getNotifications: "Receber Notificações",
  getStarted: "Iniciar",
  glass: "copo",
  glossary: "Glossário",
  goToXDashboard: "Ir para o {0} Painel de Controle",
  grossProfit: "Lucro Bruto",
  guest: "Convidado",
  guestCheckedOutAndBanned: "O convidado fez check-out e a tag foi banida.",
  guestDetails: "Detalhes do Convidado",
  guestInfoNotYetSync: "As informações do convidado ainda não foram sincronizadas",
  guestInformationYouCollect: "Informações do convidado que você coleta no momento do check-in.",
  guestList: "Lista de Convidados",
  guestName: "Nome do Convidado",
  guestNameAndOrTagId: "Nome do Convidado e/ou ID da Tag",
  guestOrTagStatus: "Status do Convidado ou Tag",
  guestProfile: "Perfil de Convidado",
  guestProfileDeleted: "Perfil de convidado excluído.",
  guestProfileDescriptionPlaceholder:
    "por exemplo, “Visitantes que fazem check-in na praça de alimentação“",
  guestProfileList: "Lista de Perfis de Convidados",
  guestProfileName: "Nome do Perfil do Convidado",
  guestProfileNameCreate: "Perfil de convidado “{0}” criado.",
  guestProfileNamePlaceholder: "por exemplo, “Convidados da praça de alimentação“",
  guestProfiles: "Perfis de Convidados",
  guestQuestions: "Perguntas de Convidados",
  guestSince: "Convidado desde {0}",
  guestSpecialRequest: "Pedidos Especiais de Convidados",
  guestTap: "Tap de Convidado",
  guestWithColonSymbol: "Convidado:",
  guests: "Convidados",
  guestsCheckedIn: "Convidados Fizeram Check In",
  guestsNewBalance: "Novo Saldo de Convidado",
  guestsPreviousBalance: "Saldo Anterior de Convidado",
  guestsPreviousBalanceTotalPaidAndNewBalance:
    "Saldo Anterior de Convidado, Total Pago e Novo Saldo",
  headOfBooking: "Head de Reserva",
  headOfReservation: "Head de Reserva",
  headerSection: "Seção do Cabeçalho",
  hello: "Olá",
  hiHeresWhatsHappening: "Olá, {0}, bem-vindo ao seu painel.",
  hiName: "Olá, {0}",
  goodMorning: "Bom dia, {0}",
  goodAfternoon: "Boa tarde, {0}",
  goodEvening: "Boa noite, {0}",
  heresHowVenueIsPerforming: "Aqui está o desempenho de {0}.",
  hidden: "Oculto",
  hide: "Ocultar",
  hideDetails: "Ocultar Detalhes",
  hideInPos: "Esconder no PDV",
  hideVariant: "Ocultar Variante",
  holdingAccountForToppedUpItems:
    "A conta de reserva para todos os créditos que são carregados em uma tag antes das vendas",
  hour: "hora",
  hours: "horas",
  id: "ID",
  ifYouLeaveThisPage:
    "Se você sair desta página, todas as alterações não salvas serão perdidas. Tem certeza de que deseja descartar as alterações?",
  ifYoudLikeToJustStopSellingProduct:
    "Se você deseja simplesmente parar de vender um produto em seu PDV, simplesmente desative-o desligando “Vender em PDV”.",
  imageTypeSize: "JPG GIF ou PNG. Tamanho máximo de 1 MB",
  in: "em",
  inProgress: "Em Progresso",
  inStock: "Em Inventário",
  inactive: "Inativo",
  include: "Incluir",
  indeterminate: "indeterminado",
  information: "Informação",
  informationToCollect: "Informações a serem coletadas no registro do convidado.",
  integrateDesc: "Integre com poderosos sistemas de gerenciamento de propriedade e muito mais.",
  integrationSettingDesc:
    "Conecte-se com outros aplicativos de negócios e produtividade para ajudar a crescer e otimizar seus negócios.",
  integrationSettings: "Configurações de Integração",
  integrations: "Integrações",
  invalidFileType: "Tipo de arquivo inválido. Os tipos de arquivo permitidos são JPG ou PNG.",
  invalidOptions: "Opção (ões) inválida (s).",
  invalidTimeRange: "Intervalo de Tempo Inválido",
  invalidToken: "Token Inválido",
  inventory: "Inventário",
  inventoryAccount: "Conta de Inventário",
  inventoryAccountMessage: "Para itens de suprimentos comprados e inventário antes de vender.",
  inventoryAccountPlaceholder: "[xxxx] - Patrimonio/Inventário",
  inventoryGainLossAccount: "Conta de Ganho/Perda de Inventário",
  inventoryGainLossAccountMessage:
    "Para discrepâncias na verificação de inventário, ajustes de inventário, etc.",
  inventoryGainLossAccountPlaceholder: "[xxxx] - Ganho/Perda nas Vendas de Inventário",
  inventoryManagement: "Gestão de inventário",
  inventoryMovement: "Movimento de Inventário",
  inventoryMovementPage: "Página de Movimento de Inventário",
  inventoryReport: "Relatório de Inventário",
  inventoryValue: "Valor de Inventário",
  invitationHasBeenSentTo: "O convite foi enviado para {0}.",
  inviteNewStaff: "Convidar Novo Funcionário",
  inviteYourVenueStaff: "Convide o funcionário de seu local, gerencie sua função e acesse seu PDV",
  isAreserveWord: "é uma palavra de reserva.",
  issuanceLimit: "Limite de Emissão",
  issue: "Emitir",
  issueFreeCredits: "Emitir Créditos Gratuitos",
  issuedBy: "Emitido por",
  issuedOn: "Emitido em",
  item: "Item",
  itemName: "Nome do Item",
  itemTax: "Imposto do Item",
  items: "Itens",
  itemsSold: "Itens Vendidos",
  lastIssuedTo: "Última Emissão Para",
  lastModifiedBy: "Modificado pela Última Vez por",
  lastModifiedOn: "Última Modificação em",
  lastName: "Último Nome",
  lastPurchasedProduct: "Último Produto Adquirido",
  lastSync: "Última Sincronização",
  lastSynced: "Última sincronização em {0}",
  lastVisitedLocation: "Último Local Visitado",
  learnMore: "Saber Mais",
  legalBusinessName: "Razão Social",
  letsGetStarted: "Vamos começar",
  liability: "Responsabilidade",
  limit: "Limite",
  limitVoucherPerPerson: "Limite de voucher emitido por pessoa",
  linkAccountingItem: "Link de Item Contábil",
  linkMiniWeb: "Link Mini Web",
  linkWithMewsAccountingItems: "Link com Itens de Contabilidade do MEWS",
  loading: "Carregando...",
  location: "Local",
  locationDesignation: "Designação do Local",
  locationName: "Nome do Local",
  locationNameAlreadyExist: "Este local já existe. Escolha um nome diferente.",
  locationNameCreated: 'Local "{0}" criado.',
  locationNameDeleted: 'Local "{0}" excluído.',
  locationNameUpdated: 'Local "{0}" atualizado.',
  locationVoucherRedeemed: "Escolha os Pontos de venda onde este voucher será resgatado.",
  locations: "Locais",
  locationsList: "Lista de Pontos de venda",
  logIn: "Login",
  login: "Login",
  loginHasEnded: "Sua sessão de login já terminou. Por favor faça login novamente.",
  loginSessionEnded: "Sessão de Login Encerrada",
  logout: "Sair",
  looksLikeAlreadyInSystem: "Parece que você já está em nosso sistema!",
  looksLikeYouEncounteredSomething:
    "Parece que você encontrou um erro, nós rastreamos esses erros automaticamente. Enquanto isso, tente atualizar.",
  looksLikeYouHaveNoLocationYet: "Parece que você ainda não tem pontos de venda.",
  lostTag: "Tag perdida",
  lostTags: "Tags Perdidas",
  lowOrOutOfStock: "Inventário Baixo ou Sem",
  lowParLevel: "Nível Par Baixo",
  lowerCaseNoneRefundable: "não reembolsável",
  lowerCaseTopUpCredits: "créditos de recarga",
  mailingList: "Lista de Mala Direta",
  manageAccountNotificationStockLevel:
    "Gerenciar contas para notificar quando um item cai para seu nível de alerta.",
  manageAndAssignQuestions:
    "Gerenciar e atribuir perguntas de check-in, créditos gratuitos e vouchers para diferentes perfis de convidados.",
  manageBusinessInfo: "Gerenciar Informações Comerciais",
  manageEmailNotif: "Gerenciar notificações por e-mail enviadas para você e seus funcionários.",
  manageHowVenueTax:
    "Gerencie como seu local cobra impostos, dependendo da sua região. Consulte um especialista em impostos para entender suas obrigações fiscais.",
  manageImportantDetailsSettings:
    "Gerencie os detalhes e regras importantes do seu local, como configurações do local, configurações de pagamento e crédito, configurações de check-in e configurações de sua conta.",
  manageInventory: "Gerenciar Inventário",
  manageInventoryAndProducts: "Gerenciar o inventário e produtos deste conjunto.",
  manageInventoryAndSupply: "Gerenciar o inventário e itens de suprimento deste produto.",
  manageNotifcations: "Gerencie alertas de e-mail e notificações enviadas para seus funcionários.",
  managePlacesYouStock:
    "Gerencie os pontos de venda em que você armazena o inventário e vende produtos",
  manageReceipts: "Gerencie a aparência e as informações de seus recibos.",
  manageSupplyItems: "Gerenciar Itens de Suprimentos",
  manageThePosDevicesVenue:
    "Gerenciar dispositivos PDV que estão logados e estão sendo usados em seu local",
  manageTheStocksPerLocation: "Gerenciar os inventários por local deste item de suprimento.",
  manageToppedUpCredits:
    "Gerenciar créditos recarregados, créditos gratuitos, créditos pós-pagos e créditos expirados.",
  manageVariants: "Gerenciar Variantes",
  manageYourAccountsSales:
    "Gerencie suas contas com relação a vendas, custo de mercadorias, impostos sobre produtos ou descontos.",
  manageYourStaffProfileDescription:
    "Gerencie seus funcionários, suas funções, designações e perfil de funcionários a que pertencem.",
  manageYourVenueSetting: "Gerencie as configurações do local, como impostos e moeda.",
  manageYourVenueSubscription:
    "Gerencie a assinatura, as informações de cobrança e as faturas do seu local.",
  manageYourVenueTax: "Adicione e gerencie como seu local cobra impostos.",
  manager: "Gerente",
  managerAuthorization: "Autorização do Gerente",
  mapAndManageAccounts:
    "Mapeie e gerencie suas contas padrão para cada processo de negócios SoCashlessVENUE.",
  mapAndManageAccountsLink: "Mapeie e gerencie suas contas em {0} para uma contabilidade adequada",
  mapYourAccounts: "Mapeie suas contas para ativos de inventário, despesas de discrepância, etc.",
  margin: "Margem",
  markUp: "Lucro",
  maximumLengthCharacters: "Máximo de {0} caracteres",
  maximumValueAllowed: "O valor máximo permitido é 20.000.000",
  maximumValueIs: "O valor máximo é ",
  measurements: "Medidas",
  milk: "leite",
  minOfNCharacters: "Mínimo de {0} caracteres",
  minimum: "Mínimo",
  minimumCharactersAllowed: "Mínimo de {0} caracteres permitidos",
  minimumOf: "Mínimo de 2 itens necessários.",
  minimumValueIs: "O valor mínimo é ",
  minute: "minuto",
  minutes: "minutos",
  missedCheckIn: "Check-in Perdido",
  missedCheckOut: "Check-out Perdido",
  mixed: "Misto",
  mobileNumber: "Número de Celular",
  month: "mês",
  months: "meses",
  monthsAfterCheckout: "meses após o check-out",
  mostPurchasedProduct: "Produto Mais Comprado",
  mostVisitedLocation: "Localização Mais Visitada",
  movement: "Movimento",
  nOptions: "{0} opções",
  nTon: "{0} a {1}",
  name: "Nome",
  nameAdded: "“{0}” adicionado.",
  nameYourProduct: "Nomeie seu produto ...",
  nameYourProductSet: "Nomeie seu conjunto de produtos ...",
  nameYourSupplyItem: "Nomeie seu item de suprimento",
  nationality: "Nacionalidade",
  needAdditionalSupportContact: "Se precisar de suporte adicional, entre em contato com {0}.",
  needHelp: "Precisa de ajuda?",
  netWeightN: "Peso líquido {0}",
  new: "Novo",
  newBalance: "Novo Saldo",
  newGuests: "Novos Convidados",
  newInviteLink: 'Novo link de convite foi enviado para "{0}"',
  newPassWord: "Nova Senha",
  newProduct: "Novo Produto",
  newProductSet: "Novo Conjunto de Produtos",
  newQuantity: "Nova Quantidade",
  newToSocashless: "Novo na SoCashless?",
  no: "Não",
  noAccountsAvailable: "Nenhuma Conta Disponível",
  noAccountsYet: "Ainda Sem Contas",
  noAvailableCategories: "Sem Categorias Disponíveis",
  noAvailableGuestProfile: "Nenhum Perfil de Convidado disponível",
  noAvailableLocations: "Sem pontos de venda disponíveis",
  noAvailableLocationsYet: "Ainda não há pontos de venda disponíveis.",
  noAvailablePaymentMethodYet: "Nenhum método de pagamento disponível ainda.",
  noAvailableStaff: "Nenhum Funcionário Disponível",
  noBannedTagsYet: "Nenhuma tag banida ainda.",
  noBookingsYet: "Ainda não há reservas.",
  noCheckInsInDateRange: "Não houve check-ins neste intervalo de datas.",
  noData: "Sem Dados",
  noDeviceAvailable: "Nenhum Dispositivo Disponível",
  noDevicesFound: "Nenhum dispositivo encontrado",
  noEndDate: "Sem data de término",
  noLocation: "Sem Local",
  noLocationAvailable: "Nenhum Local Disponível",
  noNotesFound: "Nenhuma Nota Encontrada",
  noOfGuests: "No. de Convidados",
  noOfNights: "No. de Noites",
  noProductsAvailable: "Nenhum produto disponível",
  noProductsSelected: "Nenhum produto selecionado ainda.",
  noRecordsOf: "Sem registros de",
  noRemainingBalance: "Sem Saldo Restante",
  noReportsFound: "Nenhum relatório encontrado.",
  noResultInSearch: "Não encontramos nenhum resultado para sua pesquisa.",
  noResults: "Sem Resultados",
  noResultsFound: "Nenhum Resultado Encontrado",
  noResultsMatching: "Nenhum resultado correspondente",
  noResultsMatchingX: "Nenhum resultado corresponde a “{0}”",
  noReturnCreditsInDateRange: "Não houve devolução de créditos neste intervalo de datas.",
  noSalesInDateRange: "Não houve vendas neste intervalo de datas.",
  noSearchResultsForName: "Nenhum resultado de pesquisa para {0}.",
  noStocks: "Sem Inventário",
  noTagUid: "Sem UID de Tag",
  noTagsFound: "Nenhuma tag encontrada.",
  noVoucherAvailable: "Nenhum Voucher Disponível",
  noVoucherMovement: "Nenhum movimento de voucher.",
  noVouchersSelectedYet: "Nenhum voucher selecionado ainda.",
  nonRefundable: "Não reembolsável",
  notCheckedIn: "Não Fez Check-in",
  notSellingOnPos: "Não Vendendo no PDV",
  note: "nota",
  notePreviousTransaction: "Nota: Suas transações anteriores com esses produtos serão mantidas.",
  noteTransactionStaff: "Nota: Suas transações anteriores com este funcionário serão mantidas.",
  notedByOn: "Notado por {0} em {1}",
  notes: "Notas",
  notificationSettings: "Configurações de Notificação",
  notifications: "Notificações",
  nthGuestWhoUseThisTag: "{0} convidado que usou esta tag.",
  nthStaffWhoUsedThisTag: "{0} funcionários que usaram esta tag.",
  nthUse: "{0} usam",
  numberAbbr: "N.º",
  numberOfGuests: "nº de Convidados",
  numberOfNights: "# de Noites",
  odooDescription: "Suíte ERP aberta que abrange contabilidade, estoque e compras.",
  offline: "Offline.",
  ok: "Ok",
  okay: "Ok",
  onPos: "No PDV",
  onceYouBanATag:
    "Depois de banir uma tag, essa tag não pode ser usada para transações dentro do seu local.",
  onceYouBlockATag:
    "Depois de bloquear uma tag, essa tag não pode ser usada para transações dentro do seu local.",
  onceYouCompleteStocktake:
    "Depois de concluir uma verificação de inventário, todas as quantidades reais dos itens de suprimento serão ajustadas de acordo. Essa ação não pode ser desfeita.",
  open: "Abrir",
  openReceiptPreview: "Visualizar Recibo Aberto",
  openWindow: "Abrir Janela para Pontos de venda",
  openingBalance: "Saldo Inicial",
  optionNameAlreadyExists: "O nome da opção já existe",
  options: "Opções",
  orNo: "OU#",
  orderQty: "Qtd Pedidos",
  original: "Original",
  other: "Outro",
  others: "Outros",
  overTime: "Ao longo do tempo",
  overview: "Visão Geral",
  pairedTagOnCheckin: "Tag Emparelhada no Check-in",
  pairedTags: "Tags Emparelhadas",
  parLevel: "Nível Par",
  partiallyConnected: "Parcialmente conectado",
  password: "Senha",
  passwordDoesNotMatch: "As senhas inseridas não são iguais",
  passwordIncorrect: "A senha que você digitou está incorreta.",
  passwordsDoNotMatch: "As senhas não coincidem",
  paymentAndCreditSettings: '"Configurações de Pagamento e Crédito',
  paymentGateway: "Gateway de pagamento",
  paymentGateways: "Gateways de pagamento",
  paymentMethod: "Método de Pagamento",
  paymentMethodAddedName: 'Método de Pagamento "{0}" adicionado.',
  paymentMethodAlreadyExist: "Método de pagamento já existe",
  paymentMethodName: "Nome do Método de Pagamento",
  paymentMethods: "Métodos de Pagamento",
  paymentMethodsDescription: "Crie e gerencie métodos de pagamento que você aceita em seu local.",
  paymentMethodsSettings: "Configurações de Métodos de Pagamento",
  paymentMethodsYouAccept: "Métodos de pagamento que você aceita em seu local.",
  paymentOrder: "Ordem de Pagamento",
  paymentStatus: "Status do Pagamento",
  paymentType: "Tipo de Pagamento",
  peakHours: "Horários de pico",
  permBasicVenueInformation: "Informações básicas do estabelecimento",
  permBookingsAndGuestDetails: "Reservas e dados dos hóspedes",
  permCustomPaymentMethod: "Método de pagamento personalizado",
  permHouseAccount: "Conta da casa",
  permSaleTransactions: "Transações de venda",
  perPage: "{0} por página",
  percentage: "Porcentagem",
  percentageBetween: "A porcentagem deve estar entre 1-100",
  permitNumberWithColonSymbol: "Número da Licença:",
  phone: "Telefone",
  pleaseCheckYourNetwork: "Verifique sua rede para atualizar os dados do local.",
  pleaseConnectToAnAccounting:
    "Conecte-se a uma integração de contabilidade para gerenciar seu plano de contas",
  pleaseCreateLocation:
    "Crie pelo menos 1 local para alocar os inventários deste item de suprimento.",
  pleaseCreateYourChartOfAccounts:
    "Crie seu plano de contas nas configurações de categorias de contabilidade em seu painel MEWS.",
  pleaseEnsureLocation:
    "Certifique-se de que um local não tenha transações em andamento antes de iniciar uma verificação de inventário.",
  pleaseSelectAtLeastOneRole: "Selecione pelo menos uma função.",
  pleaseSelectLocation: "Selecione um local",
  pleaseSelectStockUnit: "Selecione a Unidade de Inventário",
  pointOfSale: "Ponto de Venda",
  posDevices: "Dispositivos de Ponto de Venda",
  posProvider: "Provedor de PDV",
  postPaidCreditsIsTheAmount:
    "Os créditos pós-pagos são a quantia que um hóspede pode usar quando seu saldo chegar a zero. Quando um hóspede possui saldo de créditos pós-pagos, o valor deve ser liquidado e pago por meio de recarga ou no check-out",
  postPaidCreditsUsed: "Créditos Pós-Pagos Usados",
  postpaidCreditLimit: "Limite de Crédito Pós-Pago",
  postpaidCredits: "Créditos Pós-Pagos",
  postpaidCreditsLiabilityAccount: "Conta de Garantia de CréditosPós-Pagos",
  postpaidCreditsLiabilityAccountMessage:
    "Créditos usados quando um hóspede atinge o saldo zero. A ser pago através de recarga no momento do check-out.",
  postpaidCreditsLiabilityAccountPlaceholder: "[xxxx] - Patrimonio/Créditos Pós-Pagos",
  postpaidCreditsUsed: "Créditos Pós-Pagos Usados",
  postpaidCreditsUsedCanOnlyBeReplenished:
    '"Os créditos pós-pagos usados só podem ser repostos e pagos por recarga ou no check-out.',
  productHasVariantsEditPriceInDetail: "Este produto tem variantes, acesse os detalhes do produto para editar o preço",
  propertyManagementSystems: "Sistemas de gestão hoteleira",
  refundClaimEndDate: "Data de término do pedido de reembolso",
  refundClaimStartDate: "Data de início do pedido de reembolso",
  registeredLabel: "Registrado",
  resetToAllDay: "Redefinir para o dia todo",
  returnCreditsOutlet: "Ponto de venda de devolução de créditos",
  revenueAccountAssigned: "Conta de receita atribuída",
  saleOutlet: "Ponto de venda",
  salesByPaymentType: "Vendas por tipo de pagamento",
  salesOutlet: "Ponto de venda de vendas",
  saturday: "Sábado",
  saveQuestions: "Salvar perguntas",
  selectCreditsKeptOutlet: "Selecione o ponto de venda de créditos retidos",
  selectCreditsReceivedOutlet: "Selecione o ponto de venda de créditos recebidos",
  selectedRefundType: "Selecione o tipo de reembolso",
  selectReturnCreditsOutlet: "Selecione o ponto de venda de devolução de créditos",
  selectSalesOutlet: "Selecione o ponto de venda de vendas",
  selectService: "Selecione o serviço",
  selectTimezone: "Selecione o fuso horário",
  selectTopUpOutlet: "Selecione o ponto de venda de recargas",
  service: "Serviço",
  setRevenueAccount: "Definir conta de receita",
  setTime: "Definir horário",
  sevenRoomsDescription: "Plataforma de experiência do hóspede e reservas para operadores de hospitalidade.",
  shiftHasUnsyncedTransactions: "Este turno ainda tem transações não sincronizadas. Verifique o dispositivo deste turno e acesse a tela \"Push Venue Data\" para sincronizar.",
  showing: "Exibindo:",
  siigoDescription: "Contabilidade online com faturamento em conformidade com a DIAN para a Colômbia.",
  snAbbr: "N.º",
  socashlessConnect: "SoCashlessCONNECT",
  socashlessLogo: "Logotipo SoCashless",
  socashless: "SoCashless",
  powerYourVenue: "Potencialize seu Local com Integrações.",
  preloadedVouchers: "Vouchers Pré-Carregados",
  preparingReport: "Preparando Relatório",
  previousBalance: "Saldo Anterior",
  price: "Preço",
  pricePerOrderQty: "Preço por Quantidade de Pedidos",
  pricing: "Preços",
  pricingAndTaxes: "Preços e Impostos",
  printableItems: "Itens para Impressão",
  printableItemsSelect: "Escolha quais produtos são impressos neste perfil de impressora.",
  printerLocationsDesc: "Escolha os Pontos de venda onde este perfil de impressora pode ser usado.",
  printerProfile: "Perfil de Impressora",
  printerProfileCreated: "Perfil de impressora “{0}” criado.",
  printerProfileDeleted: "Perfil de Impressora Excluído",
  printerProfileName: "Nome do Perfil da Impressora",
  printerProfileNameAlreadyExists: "Este nome de perfil de impressora já existe.",
  printerProfileUpdated: "Perfil da Impressora “{0}” atualizado.",
  printerProfiles: "Perfis de Impressora",
  printers: "Impressoras",
  prioritizedAndUsedFirst: "priorizados e usados primeiro nos pagamentos.",
  privacy: "Privacidade",
  privacyPolicy: "política de privacidade",
  privacyPolicy2: "Política de privacidade",
  proceed: "Continuar",
  proceedToCheckout: "Continuar para o Check-out",
  processingTransactions: "Processando Transações ...",
  product: "Produto",
  productCategories: "Categorias de Produtos",
  productCategory: "Categoria de Produto",
  productCount: "Contagem de Produto",
  productDeleted: 'Produto "{0}" excluído.',
  productList: "Lista de Produtos",
  productName: "Nome do Produto",
  productRedeemed: "Produto Resgatado",
  productRemovedFromInventory: "{0} produto removido do inventário.",
  productSet: "Conjunto de Produtos",
  productSetDeleted: 'Conjunto de produtos "{0}" excluído.',
  productSetName: "Nome do Conjunto de Produtos",
  productUpdated: "{0} produto atualizado.",
  products: "Produtos",
  productsArePartOfComposite:
    "Esses produtos fazem parte de outros produtos compostos. Para excluí-los, remova-os primeiro dos produtos compostos ou exclua-os {0} com os produtos compostos que os contêm.",
  productsAreSupplyItemsAre:
    "{0} são os itens que você vende em seu local. {1} são os itens que você usa para construir seus produtos. Os itens de suprimentos são gerenciados em seu {2}.",
  productsCanBeRedeemed:
    "Escolha quais produtos de seu inventário podem ser resgatados a partir deste voucher.",
  productsDeleted: "{0} produtos excluídos.",
  productsDoesNotExist:
    "Os produtos que você deseja adicionar devem existir em todos os pontos de venda.",
  productsForDeletion:
    "{0} produto(s) com este local também podem ser excluídos. Isto não pode ser desfeito.",
  productsRemovedFromInventory: "{0} produtos removidos do inventário.",
  productsToBeDeleted: "Produtos a serem excluídos",
  productsUpdated: "{0} produtos atualizados.",
  productsVSupplyItems: "Produtos x Itens de Suprimentos",
  productsVariants: "Produtos / Variantes",
  profile: "Perfil",
  profileDiscount: "Desconto do Perfil",
  profileDiscountDescription:
    "Escolha o desconto percentual que se aplica ao gasto total deste convidado",
  profileDiscountRange: "A porcentagem deve estar entre 1-100",
  profileName: "Nome do Perfil",
  profileNameAlreadyExists: "O nome do perfil já existe, digite um nome diferente.",
  propertyManagementSystem: "Sistema de Gestão de Propriedade",
  purchasingAndInventory: "Compra e Inventário",
  qty: "Qtd",
  quantity: "Quantidade",
  quantitySupplyItems: "A quantidade de itens de suprimento usados para este produto.",
  question: "Pergunta",
  questionAddedName: "Pergunta “{0}“ adicionada.",
  questionAlreadyExist: "A pergunta já existe.",
  questionDeleted: "Pergunta “{0}“ excluída.",
  questionDescription:
    "Informações a serem coletadas no registro do convidado. Use essas perguntas atribuindo-as ao seu {0}.",
  questionSettings: "Configurações de Pergunta",
  questions: "Perguntas",
  radioButton: "Botão Interruptor",
  reachedReorderPoint: "Ponto de Encomendar Novamente Atingido",
  reallyUnbanTag: "Desbanir realmente esta tag?",
  reallyUnbanThisTagDescription:
    "O cancelamento do banimento desta tag só terá efeito na próxima vez que seus dispositivos forem sincronizados e atualizados (geralmente a cada 5 minutos quando conectado à Internet). Para refletir essas alterações imediatamente, sincronize e atualize seus dispositivos assim que cancelar o banimento desta tag.",
  reason: "Razão",
  reasonsForStay: "Razões para Ficar",
  receiptFormatting: "Formatação de Recibo",
  receiptNumber: "Número do Recibo",
  receiptSettings: "Configurações de Recibo",
  receipts: "Recibos",
  recentTransactions: "Transações Recentes",
  reconnect: "Reconectar",
  redeem: "Resgatar",
  redeemableProducts: "Produtos Resgatáveis",
  redeemed: "Resgatado",
  refreshingThisPage: "Atualizando esta página",
  refundedCredits: "Créditos Reembolsados",
  registerGuests: "Cadastrar Convidados",
  registerInfo: "Informações de Cadastro",
  registerReports: "Relatórios de Cadastro",
  registerReportsPage: "Página de Relatórios de Cadastro",
  registerStaff: "Registrar Funcionário",
  remove: "Excluir",
  removeFreeCredits: "Remover Créditos Gratuitos",
  removeFromList: "Remover da lista",
  removeNameAsYourStaff: "Remover {0} como funcionário?",
  removeStocks: "Remover Inventários",
  removeStocksConfirm: "Remover Inventários",
  removeStocksDetails: "Tem certeza de que deseja remover {0} {1} dos inventários de {2} em {3}?",
  removeThisAccount: "Remover esta conta?",
  removeThisSupplyItem: "Remova este item de suprimento primeiro dos produtos para excluí-lo.",
  removeVariant: "Remover Variante",
  removeVariantFirstFromProduct: "Primeiro remova esta variante do produto",
  removedStock: "Inventário Removido",
  reorderPoint: "Ponto de Encomendar Novamente",
  reorderPointReached: "Ponto de Encomendar Alcançado",
  reorderStocks: "Encomendar iInventários",
  reports: "Relatórios",
  reportsFailedToLoad: "Os relatórios não foram carregados.",
  reportsInfoPage: "Página de Informações de Relatórios",
  requireManagerAuthorization: "Requer autorização do gerente ao reivindicar este desconto.",
  required: "Obrigatório",
  resendInvite: "Reenviar Convite?",
  resetExpiration: "Reiniciar Expiração",
  resetTheExpirationPeriod:
    "Redefina o período de expiração assim que um convidado conclui uma transação sem fazer check-in.",
  restrictUseOfTags: "Restrinja o uso de certas tags em seu local.",
  retailPrice: "Preço de Varejo",
  retailPriceMustNotBeNegative: "O preço de varejo não deve ser negativo",
  retryReloadingChart: "Tentar Carregar o Gráfico Novamente",
  returnCredits: "Devolução de Créditos",
  returnedTags: "Tags Devolvidas",
  returnedVoucher: "Voucher Devolvido",
  returningGuests: "Convidados de Retorno",
  revenue: "Receita",
  revenueAccount: "Conta de Receita",
  revenueAccountPlaceholder: "[xxxx] - Receita/Vendas FOC",
  reviewYourDailyVenueActivity: "Revise sua atividade diária no local.",
  revokeInvite: "Revogar Convite",
  revokeThisInvite: "Revogar este convite?",
  roadMap: "Plano",
  role: "Função",
  roleAndDesignation: "Função e Designação",
  roles: "Funções",
  rooms: "Quartos",
  runEndOfDay: "Executar Fim do dia",
  sale: "Venda",
  saleDiscounts: "Receita/Descontos de Vendas",
  saleFoc: "Receita/Vendas FOC",
  saleReturn: "Retorno de Venda",
  sales: "Vendas",
  salesDiscounts: "Descontos em Vendas",
  salesDiscountsMessage: "O custo de todos os descontos aplicados.",
  salesDiscountsPlaceholder: "[xxxx] - Desconto de Vendas",
  salesFOCPlaceholder: "[xxxx] - Receita/Vendas FOC",
  salesInformation: "Informação de Vendas",
  salesReport: "Relatório de Vendas",
  save: "Salvar",
  saveAccountSetting: "Salvar Configuração de Conta",
  saveCategoryForm: "Salvar formulário de categoria",
  saveCreditSetting: "Salvar Configuração de Crédito",
  saveDeviceForm: "Salvar Formulário do Dispositivo",
  saveDiscountForm: "Salvar Formulário de Desconto",
  saveGeneralSettings: "Salvar Configurações Gerais",
  saveLocationForm: "Salvar Formulário de Local",
  saveNewSupplyItemForm: "Salvar Formulário de Novo Item de Suprimento",
  savePaymentMethod: "Salvar Método de Pagamento",
  savePrinterProfileForm: "Salvar Formulário de Perfil da Impressora",
  saveProduct: "Salvar Produto",
  saveProductSet: "Salvar Conjunto de Produtos",
  saveQuestion: "Salvar Pergunta",
  saveReceiptSettings: "Salvar Configurações de Recibo",
  saveStaffForm: "Salvar Formulário de Funcionário",
  saveStaffProfileForm: "Salvar Formulário de Perfil de Funcionário",
  saveTaxSetting: "Salvar Configuração de Impostos",
  saveVenueForm: "Salvar Formulário de Local",
  saveVoucherForm: "Salvar Formulário de Voucher",
  saveWristbandKeepingSettings: "Salvar as Configurações de Manutenção da Pulseira",
  savedChanges: "Mudanças Salvas",
  search: "Pesquisar",
  search2: "Pesquisar...",
  searchBanTags: "Pesquisar tags proibidas por tag UID",
  searchBlockedTags: "Pesquisar tags bloqueadas por tag UID",
  searchForProducts: "Pesquisar produtos ou itens de suprimentos",
  searchForStockId: "Pesquisar ID de Inventário ...",
  searchForStocktakeId: "Pesquisar ID de Verificação de Inventário...",
  searchGuestsByNameOrId: "Pesquisar convidados por nome ou ID de tag",
  searchMovementPlaceholder: "Pesquisar movimentos por nome de voucher, dispositivo, convidado",
  searchProductByKeyOrSku: "Pesquisar produtos por palavra-chave ou SKU",
  searchProductsByKeyword: "Pesquisar produtos por palavra-chave",
  searchProductsIn: "Pesquisar produtos em {0}",
  searchReportsByShiftId: "Relatórios de pesquisa por id de turno",
  searchResult: "resultado da pesquisa",
  searchResults: "Resultados da Pesquisa",
  searchSupplyItemBy: "Pesquisar item de suprimentos por nome ou SKU",
  searchTag: "Pesquisar Tag",
  searchTransactionPlaceholder:
    "Pesquisar transações por nome do convidado, ID da tag, localização, ID de check-in",
  searchVouchers: "Pesquisar Vouchers",
  second: "segundo",
  seconds: "segundos",
  selectAType: "Selecione um tipo",
  selectAccount: "Selecionar Conta",
  selectAccountPlaceholder: "Selecione Conta ...",
  selectAccountType: "Selecionar Tipo de Conta",
  selectAndMakeComposition: "Selecione a montagem e composição deste produto.",
  selectCategoriesOrProducts: "Selecione categorias ou produtos de seus pontos de venda escolhidos",
  selectCategory: "Selecionar Categoria",
  selectCountry: "Selecione o pais",
  selectDevice: "Selecionar Dispositivo",
  selectGuestProfile: "Selecionar Perfil de Convidado",
  selectItemsThisProductMadeOf:
    '"Selecione os itens de que este produto é feito. Defina a quantidade de cada item de suprimento que será deduzido por pedido de venda deste produto.',
  selectLocation: "Selecionar Local",
  selectProducts: "Selecionar Produtos",
  selectStaff: "Selecionar Funcionário",
  selectStatus: "Selecionar Status",
  selectStockLevel: "Selecionar Nível de Inventário",
  selectStockUnit: "Selecionar Unidade de Inventário",
  selectSupplyItem: "Selecionar item de suprimento",
  selectTax: "Selecionar Imposto",
  selectToIncludeCategory: "Selecione para incluir este produto em uma categoria ..",
  selectToIncludeProductSetInCategory:
    "Selecione para incluir este conjunto de produtos em uma categoria.",
  selectVenue: "Selecionar Local",
  selectVouchers: "Selecionar Vouchers",
  sellOnPos: "Vender no PDV",
  selling: "Vendendo",
  sellingOnPos: "Vendendo no PDV",
  sellingQty: "Qtd de Venda",
  serialNumber: "Número de Série",
  serialNumberAbbv: "S/N",
  set: "Definir",
  setAnAmountToLimitPostPaid:
    "Defina um valor para limitar os créditos pós-pagos permitidos de um hóspede.",
  setAsDefaultTax: "Definir como imposto padrão",
  setAsNonRefundable: "Definir como não reembolsável",
  setCode: "Definir Código",
  setExpirationPeriod: "Definir período de expiração",
  setUpYourAccount: "Crie sua conta!",
  setUpYourSoCashlessAccount: "Configure sua conta SoCashless",
  sets: "Conjuntos",
  settings: "Definições",
  share: "Compartilhar",
  shareThisLink:
    "Compartilhe este link para abrir {0} em qualquer dispositivo! Copie o link e compartilhe-o com qualquer um de seus funcionários.",
  shift: "Turno",
  shiftEnd: "Fim do Turno",
  shiftId: "ID de Turno",
  shiftStart: "Início de Turno",
  shifts: "Turnos",
  shouldBeANumber: "Deve ser um número.",
  show: "Mostrar",
  showHideColumns: "Mostrar / Ocultar Colunas",
  showLess: "Mostrar Menos",
  showMore: "Mostrar Mais",
  signIn: "Entrar",
  signInButton: "Botão de Entrar",
  signUp: "Inscrever-se",
  sku: "SKU",
  skuAlreadyExists: "SKU já existe.",
  skuStockKeepingUnit: "SKU (unidade de manutenção de inventário)",
  software: "Software",
  someArePartOfCompositeNote:
    "{0} {1} abaixo não podem ser excluídos porque fazem parte de outros produtos compostos. Para excluí-los, remova-os dos produtos compostos ou exclua-os {2} com os produtos compostos que os contêm.",
  somethingWentWrong: "Algo deu errado.",
  spend: "Gastar",
  spentOnSales: "Gasto em vendas",
  split: "Dividir",
  splitInfo: "Informações de Divisão",
  splitShare: "Parte Dividida",
  paymentMode: "Modo de Pagamento",
  edited: "Editado",
  staff: "Funcionários",
  staffCanAccess: "O funcionário pode acessar o aplicativo PDV e realizar ações.",
  staffList: "Lista de Funcionários",
  staffName: "Nome dos Funcionários",
  staffNameAndOrTagId: "Nome do funcionário e/ou ID da tag",
  staffNote: "Nota do funcionário",
  staffPaymentMethodTooltip: "O método de pagamento aceito para as funções Recarregar créditos, Vender no PDV e Registrar hóspede.",
  staffProfile: "Perfil de Funcionário",
  staffProfileDeleted: "Perfil de Funcionário excluído",
  staffProfileList: "Lista de Perfil de Funcionários",
  staffProfileName: "Nome de Perfil de Funcionário",
  staffProfileNameCreated: "Perfil de Funcionário “{0}” criado.",
  staffProfileNamePlaceholder: "Digite o nome deste perfil de funcionário...",
  staffProfiles: "Perfis de Funcionários",
  staffRemoved: "Funcionário excluído.",
  staffTagWithColonSymbol: "Tag de Funcionário:",
  staffWithColonSymbol: "Funcionário:",
  standard: "Padrão",
  start: "Começar",
  startStocktake: "Iniciar Verificação de Inventário",
  startedOn: "Começou em",
  status: "Status",
  staying: "Ficando",
  stockBelowParLevel: "O inventário está abaixo do nível ideal",
  stockLevelAlerts: "Alertas de Inventário",
  stockLevelNotificationSettings: "Configurações de Notificação de Nível de Inventário",
  stockLevels: "Níveis de Inventário",
  stockManager: "Gerenciador de Inventário",
  stockReachedReorderPoint: "O inventário atingiu o ponto de novo pedido",
  stockUnit: "Unidade de Inventário",
  stockVariance: "Variância deInventário",
  stockWeightPerN: "Peso do Inventário por {0}",
  stocks: "Inventários",
  stocktake: "Verificação de Inventário",
  stocktakeAlreadyExists: "Verificação de Inventário já existe",
  stocktakeSaved: "Verificação de Inventário Salva",
  stocktakeWithId: "Verificação de Inventário # ST- {0}",
  streetVillage: "Endereço, Cidade / Vila",
  subTotal: "Subtotal",
  subscribeAndRegister: "Inscreva-se e registe-se agora para obter um",
  subscription: "Assinatura",
  success: "Sucesso",
  sugar: "açúcar",
  suggested: "Sugerido",
  summary: "Resumo",
  sunday: "Domingo",
  supervisor: "Supervisor",
  supervisorRoleAppDesc: "Esta função tem acesso ao aplicativo e acesso limitado ao site.",
  supervisorRoleDashboardDesc:
    "Permite acesso total ao aplicativo e acesso a Reservas, Hóspedes, Transações, Relatórios, Dispositivos e Tags Banidas.",
  supplyCost: "Custo de Suprimento",
  supplyItem: "Item de Suprimento",
  supplyItemAlreadyExists: "O nome do item de suprimento já existe.",
  supplyItemDeleted: "Item de Suprimento Excluído",
  supplyItemNameCreated: "Item de suprimento “{0}” criado.",
  stockTransfers: "Transferências de Inventários",
  supplyItemSummaryPage: "Página de Resumo do Item de Suprimento",
  supplyItems: "Itens de Suprimento",
  supplyUnit: "Unidade de Suprimento",
  syncToMews: "Sincronizar com MEWS",
  table: "Mesa",
  tableManagementAndReservations: "Gestão de mesas e reservas",
  tagBanned: "Tag banida.",
  tagId: "ID de Tag",
  tagIds: "IDs de tag",
  tagInfo: "Informação de Tag",
  tagUID: "Tag UID",
  tagUnbanned: "Tag não banida.",
  tags: "Tags",
  tagsIssued: "Tags Emitidas",
  tapCount: "Contagem de Toques",
  tapStatus: "Status de Toques",
  tax: "Imposto",
  taxAddedName: 'Imposto "{0}" adicionado.',
  taxAlreadyExists: "O imposto já existe.",
  taxEditNote:
    "Nota: Os produtos vinculados a este imposto serão atualizados automaticamente. Isso não afetará as vendas anteriores.",
  taxEg: "por exemplo, “Imposto sobre Valor Agregado“",
  taxIncluded: "Imposto incluído",
  taxName: "Nome ddo Imposto",
  taxNumber: "Número de Identificação Fiscal",
  taxOnPurchasesAccount: "Imposto sobre a Conta de Compras",
  taxOnPurchasesAccountMessage: "IVA e outros impostos sobre pedidos de compra.",
  taxOnPurchasesAccountPlaceholder: "[xxxx] - Passivo/Imposto de Compras",
  taxOnSalesLiabilityAccount: "Imposto sobre a Conta de Passivo de Vendas",
  taxOnSalesLiabilityAccountMessage: "A conta padrão para impostos cobrados para cada produto.",
  taxOnSalesLiabilityAccountPlaceholder: "[xxxx] -Passivo/Imposto sobre Vendas",
  taxPercentageAndValue: "",
  taxRate: "Taxa de Imposto",
  taxSettings: "Configurações Fiscais",
  taxes: "Impostos",
  termsAndConditions: "Termos e Condições",
  termsInAllowingAccess:
    "Ao clicar em Permitir acesso, você autoriza {0} a usar, receber e armazenar suas informações. Revise {1} de {2} e {3}. Você pode interromper a qualquer momento nas configurações de Integração de sua conta SoCashless.",
  termsInSignUp: "Ao me inscrever, eu concordo com os {0}, {1} e {2} da SoCashless.",
  termsInSoCashlessSignUp: "Ao me inscrever, eu concordo com os {0} da SoCashless.",
  termsOfService: "termos de serviço",
  termsOfUse: "Termos de Uso",
  textbox: "Caixa de Texto",
  theLinkYouAreTryingToAccess: "O link que você está tentando acessar não é do seu Local.",
  theLinkYouAreTryingToAccessDoesNotBelongToLocation:
    "O link que você está tentando acessar não é de seu local atribuído",
  theShiftAndTransactionDetails:
    "Os detalhes do turno e das transações serão exibidos aqui assim que o turno for encerrado na registradora.",
  thereIsSomeError:
    "Pps! Existe algum erro em nosso lado. Por favor, tenha paciência e verifique novamente mais tarde.",
  thereNthOtherProducts:
    "{0} {1} outros produtos com este local e outros locais permanecerão em seu inventário.",
  theseProductsCannotBeDeleted: "Esses produtos não podem ser excluídos.",
  thisAppRequests: "Este aplicativo solicita as seguintes informações:",
  thisAppWouldRead: "Este aplicativo poderia ler e/ou gravar as seguintes informações:",
  thisArticle: "Este artigo",
  thisEmailIsAlreadyAdded: "Este email já foi adicionado.",
  thisEmailIsInvalid: "Este email é Inválido.",
  thisFieldIsRequired: "Este campo é obrigatório.",
  thisMonth: "Este mês",
  thisProductNameAlreadyExists: "Este nome de produto já existe",
  thisProductsHasMultipleVariant: "Este produto tem várias opções, como tamanho, cor, sabor, etc.",
  thisQuestionIsLinkedToNProfiles: "Esta pergunta está vinculada a {0} perfis de convidados.",
  thisServesAsAnOfficialReceipt: "- ISSO SERVE COMO UM RECIBO OFICIAL -",
  thisSkuExists: "Este SKU já existe",
  thisStaffHasNpLongerAccess:
    "Este funcionário não terá mais acesso a {0}. Essa ação não pode ser desfeita.",
  thisTagIdIsAlreadyBanned: "Este ID de Tag já foi banido.",
  thisVenueFreeTrial: "Este local estará em teste gratuito pelos primeiros 30 dias.",
  thisWeek: "Esta semana",
  thursday: "Quinta-feira",
  ticketId: "ID do ticket",
  time: "Tempo",
  timeAccessed: "Hora de acesso",
  timeEnded: "Tempo Finalizado",
  timeRange: "Intervalo de Tempo",
  timeStarted: "Tempo de Início",
  to: "a",
  toAddMoreCreditsToATag:
    "Para adicionar mais créditos a uma tag, os convidados podem ser capazes de",
  toBeCheckedIn: "A Fazer Check-in",
  toBeCheckedOut: "A Fazer Check-out",
  toContinueCreatingDiscount: "Para continuar criando este desconto, primeiro crie um local.",
  toContinueCreatingProducts: "Para continuar criando este produto, primeiro crie um local.",
  toContinueCreatingStaff: "Para continuar criando este funcionário , primeiro crie um local.",
  toContinueCreatingStocktake:
    "Para continuar criando esta verificação de inventário, primeiro crie um local.",
  toDeleteItem: "para excluir este item.",
  today: "Hoje",
  together: "Juntos",
  toLabel: "Até",
  topCategoriesBySales: "Principais Categorias por Vendas",
  topLocations: "Principais Pontos de venda",
  toppedUp: "Recarregado",
  topProducts: "Principais Produtos",
  topSpendingGuests: "Convidados que Mais Gastam",
  topupAndReturnCredits: "Recarregar e Devolver Créditos",
  topupCredits: "Recarregar Créditos",
  topUpOutlet: "Ponto de venda de recargas",
  total: "Total",
  totalAmount: "Valor Total",
  totalBookings: "Total de Reservas",
  totalFreeCreditsIssued: "Total de Créditos Gratuitos Emitidos",
  totalFreeCreditsRemoved: "Total de Créditos Gratuitos Removidos",
  totalInStock: "Total em Inventário",
  totalPaid: "Total Pago",
  totalProductSales: "Vendas Totais do Produto",
  totalRefundedCredits: "Total de Créditos Reembolsados",
  totalRemoved: "Total Removido",
  totalReturnCredits: "Total de Devolução de Créditos",
  totalReturnedCredits: "Total de Créditos Devolvidos",
  totalSales: "Total de Vendas",
  totalSpent: "Total Gasto",
  totalSpentToDate: "Total Gasto até a Data",
  totalStocksPerLocation: "Inventário Total por Local",
  totalTagsUsed: "Total de Tags Emitidas",
  totalTax: "Imposto Total",
  totalTopUps: "Total de Recargas",
  totalTopupCredits: "Total de Créditos de Recarga",
  totalTransactions: "Total de Transações",
  totalUse: "Uso Total",
  totalVisits: "Visitas Totais {0}",
  totals: "Totais",
  trackAndManage: "Rastreie e gerencie suas contagens manuais de inventário.",
  trackEveryGuestCheckedIn:
    "Rastreie todos os convidados que fizeram check-in em seu local e veja seus produtos e locais favoritos",
  trackWhichItemsLow:
    "Rastreie quais itens estão com poucos inventários e precisam ser reabastecidos",
  trackedInventory: "Inventário Rastreado",
  transaction: "Transação",
  transactionId: "ID de Transação",
  transactionInfoPage: "Página de Informações de Transação",
  transactionsNotSynchronizingToMews: "As transações não estão sincronizando com o MEWS?",
  transactionStatus: "Status da Transação",
  transactionType: "Tipo de Transação",
  transactions: "Transações",
  transactionsFailedToProcess: "as transações falharam no processamento.",
  transactionsPage: "Página de Transações",
  transferQuantityCannotExceedOriginal: "A quantidade transferida não pode ser maior que a quantidade original",
  try: "Tente:",
  tuesday: "Terça-feira",
  turnOffPos: "Desativar a venda de {0} {1}?",
  turnOnPos: "Ativar venda de {0} {1}?",
  txnId: "Id de Trans.: #",
  type: "Digite",
  typeAQuestion: "Digite uma pergunta",
  typeAReason: "Digite um motivo ...",
  typeAnOption: "Digite uma opção",
  typeDisconnect: "Digite DISCONNECT em maiúsculas para confirmar",
  typeHere: "Digite aqui...",
  typeToSearch: "Digite para pesquisar um item!",
  typeToSetAccountCode: "Digite para definir/selecionar um código de conta.",
  unableToDelete: "Incapaz de Excluir",
  unableToLoadTheMap: "Não foi possível carregar o mapa. Verifique sua conexão com a internet e tente novamente.",
  unableToValidateTheFile: "Não foi possível validar o arquivo.",
  unbaleToUploadMoreThanMb: "Incapaz de carregar mais de 1 MB.",
  unban: "Cancelar Banimento",
  unbanTag: "Cancelar Banimento Tag",
  unbanningWillMakeTagAccessible:
    "O cancelamento do banimento tornará essa tag acessível em seu local.",
  uncategorized: "Sem categoria",
  undo: "DESFAZER",
  unitSold: "Unidade Vendida",
  unitsSold: "Unidades Vendidas",
  unknown: "Desconhecido",
  unspentCredit: "Crédito não gasto",
  updatedFrom: "Atualizado de",
  transferFrom: "Transferido de",
  updatedOn: "atualizado em {0}",
  transferTo: "Transferir para",
  uploadPhoto: "Carregar Foto",
  uponRegistration:
    "no momento do registro ou com qualquer funcionário de carregamento/quiosque dentro do local.",
  usage: "Uso",
  usageDatePeriod: "Período de Data de Uso",
  useVenueAppAndLogin:
    "Use o App e faça login com sua tag NFC ativada ou com seu nome de usuário ou senha atual.",
  used: "Usado",
  usesLastIssuedTo: "usos, última emissão para",
  validUntilWithColonSymbol: "Válido Até;",
  value: "Valor",
  valueBetween: "O valor deve estar entre",
  valueCanStillChangeTooltip: "Este valor ainda pode mudar se os hóspedes continuarem gastando créditos no seu estabelecimento.",
  valueRedeemed: "Valor Resgatado",
  values: "valores",
  variant: "Variante",
  variantAlreadyExist: "Variante já existe",
  variantIsCurrentlyBeingUsed: "A variante está sendo usada no seguinte produto",
  variants: "Variantes",
  vatReg: "Reg. IVA",
  venueCurrency: "Moeda do Local",
  venueDashboard: "Painel de Controle do Local",
  venueDetails: "Detalhes do Local",
  venueLocation: "Localização do Local",
  venueName: "Nome do Local",
  venueNameAlreadyExist: "O nome do local já existe, escolha outro nome",
  venueSettings: "Configurações do Local",
  view: "Ver",
  viewAllTransactions: "Ver Todas as Transações",
  viewAndExportDiscountReport:
    "Veja e exporte a lista de seus descontos e o valor total deduzido de cada desconto",
  viewAndExportEachClosedRegister:
    "Veja e exporte cada relatório de registro fechado feito por seu funcionário",
  viewAndExportSalesReportByCategories: "Veja e exporte seu relatório de vendas por categorias",
  viewAndExportVoucherReport:
    "Veja e exporte todos os vouchers aplicados em produtos resgatados e o valor total do varejo e suprimentos resgatados por cada voucher",
  viewBasicSummary: "Ver resumo básico",
  viewBillingStatement: "Ver Extrato de Cobrança",
  viewBookingInfo:
    "Veja informações de reserva em diferentes plataformas, como MEWS, SoCashless Ticketing e muito mais!",
  viewCategoryDetails: "Exibir Detalhes da Categoria",
  viewDetails: "Ver Detalhes",
  viewDevice: "Ver Dispositivo",
  viewDiscountDetails: "Ver Detalhes do Desconto",
  viewEveryTransactions:
    "Veja todas as transações feitas em seu local dentro de um determinado período de tempo",
  viewFullDetails: "Ver detalhes completos",
  viewIntegrations: "Ver Integrações",
  viewNOfNTransactions: "Ver {0} / {1} Transações",
  viewNTransactions: "Ver {0} Transações",
  viewPlansAndPricing: "Ver Planos e Preços",
  viewPreview: "Ver Preview",
  viewTaxSettings: "Ver Configurações de Impostos",
  viewTheSalesSummaryOfYourVenue:
    "Veja o resumo de vendas de seu local e seus principais locais, produtos e muito mais.",
  viewVoucherDetails: "Ver Detalhes do Voucher",
  void: "Cancelar",
  voidAuthorization: "Autorização de Cancelamento",
  voidConfirmation: "Tem certeza que deseja cancelar {0} Esta ação não pode ser desfeita.",
  voidId: "Cancelar {0}?",
  paymentInfo: "Informação de Pagamento",
  includedServiceCharge: "Taxa de serviço incluída.",
  voidInfo: "Informação de Cancelamento",
  voidReason: "Razão de Cancelamento",
  voids: "Anulações",
  voidStocktake: "Cancelar Verificação de Inventário",
  voided: "Cancelado",
  voidedBy: "Cancelado por",
  voidedItems: "Itens Cancelados",
  voidedOn: "Cancelado em",
  voidedValue: "Valor Cancelado",
  voucher: "Voucher",
  voucherApplied: "Voucher Aplicado",
  voucherAvailable: "Este voucher está disponível para emissão em seu local.",
  voucherCreated: "{0} adicionado.",
  voucherDeleted: "Voucher {0} excluído.",
  voucherMovementPage: "Página de Movimento de Voucher",
  voucherName: "Nome do Voucher",
  voucherNameAlreadyExist: "Este nome de voucher já existe.",
  voucherReport: "Relatório de Voucher",
  voucherRetailValue: "Valor de Varejo de Vouchers",
  voucherSupplyValue: "Valor de Fornecimento de Vouchers",
  voucherType: "Tipo de Voucher",
  voucherUpdated: "Voucher Atualizado",
  vouchers: "Vouchers",
  vouchersCreationLimitInfo:
    "Você só pode criar um máximo de 8 vouchers por local. Você pode excluir vouchers expirados ou inativos para abrir espaço para mais vouchers.",
  vouchersIssued: "Vouchers Emitidos",
  vouchersListPage: "Página de Lista de Vouchers",
  vouchersMaximumNumberReached: "Número máximo de vouchers atingido.",
  vouchersRedeemed: "Vouchers Resgatados",
  vouchersRemoved: "Vouchers Removidos",
  vouchersUsage: "Uso de Vouchers",
  weBuildCustomIntegrations: "Criamos integrações personalizadas com seus sistemas existentes. Conte-nos o que você precisa.",
  weDidNotFoundReports: "Não encontramos nenhum relatório para seus filtros.",
  wednesday: "Quarta-feira",
  week: "Semana",
  weeksAfterCheckout: "semanas após o check-out",
  weightInGrams: "Peso em gramas",
  welcomeBack: "Bem vindo de volta!",
  whenAnItemAlertLevel: "Quando um item cai para seu nível de alerta.",
  whole: "Inteiro",
  wholeProduct: "Produtos Inteiros",
  withPendingPayments: "Com Pagamentos Pendentes",
  withRemainingBalance: "Com Saldo Remanescente",
  wristbandKeeping: "Mantendo Pulseira",
  wristbandTag: "Tag de Pulseira",
  wristbandTagKeeping: "Manutenção de Tag de Pulseira",
  wristbandTagSettings: "Configurações de Tag de Pulseira",
  xByHourOfDay: "{0} por hora do dia",
  xConnectedFailed:
    "Parece que não conseguimos reconhecer este token de acesso. Consulte as instruções abaixo para recuperar seu token de acesso adequado.",
  xConnectedSuccessfully: "{0} Conectado com Sucesso",
  xIntegration: "Integração {0}",
  xOverTime: "{0} ao longo do tempo",
  xY: "{0} {1}",
  year: "ano",
  years: "anos",
  yes: "Sim",
  youAreAboutToDelete: 'Você está prestes a excluir o {0} "{1}". Isto não pode ser desfeito.',
  youAreAboutToDeleteAQuestionThatIsLinked:
    "Você está prestes a excluir uma pergunta que está vinculada a um perfil de convidado. Isto não pode ser desfeito.",
  youAreAboutToDeleteGuestProfile:
    "Você está prestes a excluir este perfil de convidado. Isto não pode ser desfeito.",
  youAreAboutToDeleteMultiple: "Você está prestes a excluir o {0} {1}. Isto não pode ser desfeito.",
  youAreAboutToDeletePaymentMethod: 'Você está prestes a remover o método de pagamento "{0}".',
  youAreAboutToDeleteQuestion:
    "Você está prestes a excluir esta questão. Isto não pode ser desfeito.",
  youAreAboutToDeleteStaffName:
    "Você está prestes a remover {0} de seus funcionários. Este funcionário não terá mais acesso a {1}. Essa ação não pode ser desfeita.",
  youAreAboutToDeleteStaffProfile:
    "Você está prestes a deletar este perfil de funcionário. Isto não pode ser desfeito.",
  youAreAboutToDeleteTax: 'Você está prestes a remover o imposto "{0}".',
  youAreAboutToDisconnect:
    "Você está prestes a desconectar e remover permanentemente todas as informações deste aplicativo.",
  youAreAboutToRemoveFromMailingList:
    "Você está prestes a remover {0} desta lista de distribuição. Esta conta não poderá receber alertas de inventário.",
  youAreAboutToRemoveMultipleProduct:
    "Você está prestes a remover {0} produtos e suas variantes de seu inventário e de todos os seus locais. Isto não pode ser desfeito.",
  youAreAboutToRemoveProduct:
    "Você está prestes a remover este produto de seu inventário e de todos os seus locais. Isto não pode ser desfeito.",
  youAreAboutToRemoveVariantProduct:
    "Você está prestes a remover este produto e suas {0} variantes de seu inventário e de todos os seus locais. Isto não pode ser desfeito.",
  youAreAssigned: "Você está atribuído com as seguintes funções:",
  youAreLoggedInAs: "Você está conectado como {0}",
  youCanChangeThisLater: "Você pode mudar isso mais tarde!",
  youCanFindMoreInformationAboutThisHere: "Você pode encontrar mais informações sobre isso aqui.",
  youCanNowLogin: "Agora você pode fazer o login usando seu e-mail e senha.",
  youDontHavePermission: "Você não tem permissão para acessar este link",
  youHaveUnsavedChanges: "Você tem alterações não salvas nesta página.",
  youllFindYourBookingsHere: "Você encontrará suas reservas aqui.",
  yourCurrentAssignedRoles: "Suas funções atribuídas atualmente são",
  yourGeneralSettings: "Suas configurações gerais, como nome do local e moeda.",
  yourMailingIsEmpty: "Sua lista de e-mails ainda está vazia.",
  yourVenues: "Seus Pontos de venda",
  youveReachedTheEndOfTheList: "Você chegou ao fim da lista.",
  zeroInventory: "Inventário Zero",
  accessControlSidebar: "Controle de Acesso",
  feesAndSurcharges: "Taxas e Sobretaxas",
  reservations: "Reservas",
  frontOfHouse: "Front Office",
  home: "Painel",
  dailyClose: "Relatórios de Fim de Dia",
  stock: "Inventários",
  refunds: "Reembolsos",
  accepted: "Aceito",
  acceptedByDian: "Aceito por Dian",
  accessControl: "Controle de acesso",
  accessControlReport: "Relatório de controle de acesso",
  accessControlRoleAppDesc: "Esta função não tem acesso ao site.",
  accessControlRoleDashboardDesc: "Permitir acesso ao Check Access do aplicativo.",
  accessKey: "Chave de acesso",
  accessPoint: "Ponto de acesso",
  accessPointCreateSuccess: "Ponto de acesso criado com sucesso",
  accessPointExisted: "Este ponto de acesso já existia. Escolha um nome diferente",
  accessPointName: "Nome do ponto de acesso",
  accessURLOrQRCode: "URL de acesso ou QR Code",
  activateOnOnlineMenu: "Ativar no Menu Online",
  activateOnPOS: "Ativar no ponto de venda (POS)",
  addAndManageAdditionalCharge: "Adicione e gerencie cobranças adicionais para venda no PDV.",
  addAProduct: "Adicionar um item",
  addASupplyItem: "Adicionar um item de estoque",
  addCharge: "Adicionar cobrança",
  additionalChargeReport: "Relatório de cobrança adicional",
  additionalCharges: "Encargos Adicionais",
  addOptions: "Adicionar opções",
  addPaymentGateway: "Adicionar gateway de pagamento",
  addProductLimit: "Para adicionar mais itens, tente excluir alguns itens para criar novos ou peça ao proprietário do local para aumentar o limite de itens!",
  addProductLimitOwner: "Para adicionar mais itens, tente excluir alguns itens para criar novos ou atualizar seu plano para aumentar o limite de itens!",
  addQty: "Adicionar quantidade",
  addStaffLimit: "Para adicionar mais funcionários, tente remover alguns funcionários ou peça ao proprietário do local para aumentar o limite de funcionários!",
  addStaffLimitOwner: "Para adicionar mais funcionários, tente remover alguns funcionários ou atualize seu plano para aumentar o limite de funcionários!",
  addSupplyItem: "Adicionar item de estoque",
  adjustStockSuccessfully: "Ajustar estoque com sucesso",
  advancedReporting: "Relatórios avançados",
  allAccessPoints: "Todos os pontos de acesso",
  allowAndSetTip: "Permitir gorjeta e definir porcentagens",
  allowBargainDesc: "Ao marcar isso, a equipe pode alterar o preço do item no PDV",
  allowBargainOnThisProduct: "Permitir que este item seja negociado",
  allowCustomTip: "Permitir que os convidados adicionem dicas personalizadas",
  allowedAccessPoint: "Ponto de acesso permitido",
  allowedGuestProfile: "Perfil de convidado permitido",
  allowGuestProfile: "Permitir perfil de convidado",
  allowInstallationFromUnknownSources: "Permitir instalação de fontes desconhecidas",
  allowInstallationFromUnknownSourcesDesc: "Pode ser necessário ativar esta configuração nas configurações de segurança do seu dispositivo para instalar aplicativos fora da loja de aplicativos oficial. As etapas exatas podem variar dependendo do sistema operacional do seu dispositivo",
  allResponse: "Todas as respostas",
  allSources: "Todas as fontes",
  allState: "Todos os estados",
  allTransactionTypes: "Todos os tipos de transação",
  allVenues: "Todos os locais",
  andManyMore: "e muito mais!",
  anHourAgo: "há uma hora",
  appDate: "Data de instalação/atualização do aplicativo",
  appReinstall: "Reinstalação do aplicativo",
  appVersion: "Versão do aplicativo",
  areYouSureSentToDian: "Tem certeza de que deseja enviar esta fatura para Dian? Verifique novamente o destinatário antes de continuar.",
  areYouSureYouWantToDeleteCharge: "Tem certeza de que deseja excluir o item de cobrança {0}",
  areYouSureYouWantToDeletePaymentGatewaySetting: "Tem certeza de que deseja excluir “{0}”? Ele não estará mais disponível nas suas configurações de pagamento.",
  areYouSureYouWantToSetAsDefaultPaymentGatewaySetting: "Tem certeza de que deseja definir “{0}” como gateway de pagamento padrão?",
  askVenueOwnerToUpgradePlan: "Peça ao proprietário do local para atualizar seu plano e começar a usar esse recurso.",
  askYourAdminToUpdateAccess: "Se você precisa de acesso ao painel, peça ao seu administrador para atualizar suas permissões de acesso.",
  atLeast1GuestProfile: "É necessário pelo menos 1 perfil de convidado",
  automaticallyAddThisChargeToTheCart: "Adicionar automaticamente esta cobrança ao carrinho?",
  automaticallyAddThisChargeToTheCartDesc: "Assim que o primeiro item for adicionado ao carrinho, essa cobrança será adicionada automaticamente. A equipe pode remover essa cobrança.",
  available: "Disponível",
  awaiting: "Aguardando",
  backOffice: "Backoffice",
  backOfficeRoleAppDesc: "Esta função não tem funções relacionadas ao aplicativo e não seria capaz de fazer login no dispositivo.",
  backOfficeRoleDashboardDesc: "Permite acesso a insights, vendas, equipes, perfil de convidado, vouchers, descontos, perfil de impressora e configurações do painel",
  balance: "Equilíbrio",
  balanceMovementsDescription: "Veja de qual local dentro do grupo de locais veio o saldo dos convidados",
  balanceMovementsIn: "Equilibre os movimentos",
  balanceMovementsInPage: "Equilibre os movimentos",
  balanceMovementsOut: "Equilibre os movimentos",
  balanceMovementsOutPage: "Equilibre os movimentos",
  bargainAllowed: "Negociação permitida",
  bargainRequiresApproval: "A negociação requer aprovação",
  bargainRequiresApprovalOnThisProduct: "Exigir autorização do gerente ao alterar o preço deste item no PDV",
  beforeUpdatingTheAppPleaseEnsureAllDataIsSyncedBy: "Antes de atualizar o aplicativo, certifique-se de que todos os dados sejam sincronizados:",
  billedTo: "Faturado para",
  bookingAccomodation: "Reserva de acomodação",
  bookingGuests: "Reserva de Hóspedes",
  bookingPrice: "Preço de reserva",
  bookingStatus: "Estado da reserva",
  businessDetails: "Detalhes do negócio",
  cacheCleared: "Cache limpo",
  cancelCloseShift: "Cancelar Fechar Turno",
  cardApprovalNumber: "Aprovação do Cartão Não",
  cardNumber: "Cartão Não",
  cashlessTransactionsWithDoor: "transações sem dinheiro com ativação de fechadura de porta!",
  cashSales: "Vendas à vista",
  categoryNameReserved: "O nome da categoria é reservado. Por favor, use outro nome.",
  changelog: "Registro de alterações",
  changesSavedSuccessfully: "Alterações salvas com sucesso",
  charge: "Cobrar",
  chargeAmount: "Valor da cobrança",
  chargeCalculation: "Cálculo de cobrança",
  chargeDeleted: "Cobrança {0} excluída",
  chargeItem: "Item de cobrança",
  chargeName: "Nome da cobrança",
  checkinAmount: "Valor do check-in",
  checkoutOurEbook: "Confira também nosso e-book sobre como otimizar seu local!",
  chooseAInventoryGroup: "Escolha um grupo de inventário",
  chooseAPaymentMethod: "Escolha um método de pagamento",
  chooseASaleTax: "Escolha um imposto sobre vendas",
  clickHere: "Clique aqui",
  close: "Fechar",
  closeShift: "Fechar turno",
  closeShiftWarning: "Certifique-se de que todas as transações estejam sincronizadas antes de forçar o fechamento do turno e use isso apenas se não conseguir fechar o turno no aplicativo.",
  cloudbeds: "Camas de nuvem",
  codeMustBeUnique: "O código deve ser único",
  comingSoon: "Em breve",
  companyRegistrationNo: "Número de registro da empresa",
  confirm: "Confirmar",
  confirmationPending: "Confirmação pendente",
  confirmImport: "Confirmar importação",
  confirmImportDesc: "Tem certeza de que deseja importar itens de estoque?",
  confirmStockAdjustment: "Confirmar ajuste de estoque",
  confirmTransfer: "Confirmar transferência",
  connect: "Conectar",
  connectedSuccessfully: "Conectado com sucesso",
  connectPurchasePlus: "Conecte o Purchase Plus à sua conta SoCashless.",
  connectStatus: "Status de conexão",
  copiedCUEFnumber: "Número CUEF copiado",
  copiedCUFEnumber: "Número CUFE copiado",
  copy: "Cópia",
  copyTheApkDownloadUrl: "Copie o URL de download do APK fornecido acima ou escaneie o código QR com um aplicativo de leitura QR.",
  createAccessPoint: "Criar ponto de acesso",
  createAccountCode: "Criar código de conta",
  createNewCharge: "Criar nova cobrança",
  createVenue: "Criar local",
  createVenuePage: "Criar página do local",
  credentialsAreInvalid: "Ops, algumas informações são inválidas. Por favor insira os dados corretos e tente novamente.",
  creditCard: "Cartão de crédito",
  creditDebit: "Crédito/Débito",
  creditDebitSales: "Vendas de crédito/débito",
  creditsKept: "Créditos mantidos",
  creditsKeptByGuests: "Créditos mantidos pelos hóspedes",
  creditsReceived: "Créditos recebidos",
  creditsReceivedFromVenues: "Créditos recebidos de outros locais",
  cufe: "CUFE",
  currentQty: "Quantidade atual",
  customLabel: "Etiqueta personalizada",
  customName: "Nome personalizado",
  customNameIsAlreadyExisting: "O nome personalizado já existe.",
  daily: "Diário",
  dataError: "Erro de dados",
  dataIncorrectly: "Dados incorretos",
  dateAndTime: "Data e hora",
  dayEnd: "Fim do dia",
  dayStart: "Início do dia",
  daySummary: "Resumo do dia",
  defaultInventoryGroup: "Grupo de inventário padrão",
  defaultMode: "Modo padrão",
  defaultModeSettingDesc: "Por padrão, o aplicativo móvel será configurado para este modo:",
  defaultTableName: "Nome da tabela padrão",
  deleteAccessPoint: "Excluir ponto de acesso",
  deleteAccessPointDesc: "Tem certeza de que deseja excluir este ponto de acesso?",
  deleteCharge: "Excluir cobrança",
  deleteChargeFailed: "Não foi possível excluir a cobrança. Tente novamente mais tarde",
  deletedSuccessfully: "Excluído com sucesso",
  deletePaymentGateway: "Excluir gateway de pagamento",
  deleteStaffModalDesc: "Você está prestes a remover funcionários. Essas equipes não terão mais acesso ao Local. Esta ação não pode ser desfeita.",
  deleteStaffModalNote: "Observação: suas transações anteriores com essa equipe serão retidas",
  deleteStaffSuccessfully: "Excluir equipe com sucesso",
  denominations: "Denominações",
  destinationLocation: "Local de destino",
  destinationLocationNewQty: "Local de destino nova quantidade",
  device: "Dispositivo",
  deviceLimitExceeded: "Você está usando dispositivos {0} que excedem o limite do seu plano de dispositivos {1}. Entre em contato com o proprietário do local para atualizar seu plano.",
  deviceLimitExceededManager: "Você está usando dispositivos {0} que excedem o limite do seu plano de dispositivos {1}. Atualize seu plano.",
  deviceUid: "UID do dispositivo",
  dianError: "Erro Dian",
  directory: "Diretório",
  disabled: "Desabilitado",
  disclaimer: "Isenção de responsabilidade",
  disclaimerDesc: "Informamos que o uso de versões mais antigas do nosso aplicativo não é recomendado e pode resultar em problemas de desempenho ou vulnerabilidades de segurança. Para garantir o desempenho ideal e o mais alto nível de segurança, recomendamos fortemente a atualização para a versão mais recente do nosso aplicativo o mais rápido possível.\nObrigado pela sua compreensão e cooperação",
  discountAmount: "Valor do desconto",
  displayedIn: "Exibido em",
  displayName: "Nome do comerciante",
  downloadAndSync: "Baixe o aplicativo SoCashlessVENUE e sincronize sua primeira transação",
  downloadAPK: "Baixar APK",
  downloadTemplate: "Baixar modelo",
  editAccessPoint: "Editar ponto de acesso",
  editCharge: "Editar cobrança",
  editDetails: "Editar detalhes",
  editDevice: "Editar dispositivo",
  editPaymentGateway: "Editar gateway de pagamento",
  editSFTPDetails: "Editar detalhes do SFTP",
  eInvoice: "Fatura eletrônica",
  eInvoiceSyncSuccessfully: "A fatura eletrônica foi sincronizada com sucesso",
  enableDifferentiateEntryExit: "Habilitar entrada/saída diferenciada",
  enableTip: "Ativar dica?",
  endedBy: "Terminado por",
  endOfDayCompleted: "Fechamento diário concluído",
  endOfDayFailed: "Falha ao concluir o fechamento diário",
  endOfDayReportsListPage: "Página de lista de relatórios de fechamento diário",
  endOfDayRunning: "O fechamento diário está em execução. Atualize a página para atualizar o status do tempo de término do EOD.",
  error: "Erro",
  eventMode: "Modo de Evento",
  exportGuestReport: "Exportar relatório de convidados",
  exportList: "Lista de exportação",
  exportTaxReport: "Relatório de Imposto de Exportação",
  externalPaymentStatus: "Status de pagamento externo",
  externalPayment: "Pagamento externo",
  extremelyHighDenominations: "Denominações extremamente altas",
  featureLocked: "Recurso bloqueado",
  female: "Fêmea",
  fileImported: "Arquivo importado",
  findSimilar: "Encontrar semelhante",
  followTheOnScreenInstructionsToCompleteTheDownloadAndInstallation: "Siga as instruções na tela para concluir o download e a instalação.",
  forDevicesWithoutTheGooglePlayStore: "Para dispositivos sem Google Play Store:",
  forProperReportingAndTo: "Para relatórios adequados e para manter seu painel atualizado, execute o Daily Close diariamente para evitar qualquer perda de dados.",
  forProperReportingWithYourMews: "Para relatórios adequados com sua conta MEWS, certifique-se de que a janela do histórico editável da sua contabilidade esteja definida para 7 dias. Execute o Daily Close diariamente para evitar qualquer perda de dados.",
  freeCreditsKept: "Créditos gratuitos mantidos",
  freeCreditsReceived: "Créditos gratuitos recebidos",
  freeCreditsReport: "Relatório de créditos grátis",
  from: "De",
  frontOffice: "Recepção",
  frontOfficeRoleAppDesc: "Esta função não tem funções relacionadas ao aplicativo e não seria capaz de fazer login no dispositivo.",
  frontOfficeRoleDashboardDesc: "Permite acesso a insights, reservas, convidados, transações, relatórios, dispositivos e tags de bloqueio do painel",
  future: "Futuro",
  generateAndDownload: "Gerar e baixar",
  generateQRCode: "Gerar código QR",
  generateQRDescription: "Gere e imprima códigos QR para os clientes digitalizarem e fazerem pedidos no menu online deste local.",
  getSocashlessVENUEeBook: "Obtenha o e-book SoCashlessVENUE",
  goToThe: "Vá para o",
  goToTheSiigoApiKey: "tela do seu painel Siigo para encontrar sua chave API.",
  goToVenueTabAndTapOnPushVenueData: "Vá para a guia “Local” e toque em Push Venue Data",
  guestId: "ID do convidado",
  guestProfileAmountPlaceholder: "0,00",
  guestsStatus: "Status dos convidados",
  guidelineDownloadOrUpdateApp: "Diretriz sobre como baixar ou atualizar o aplicativo",
  helpCenter: "Central de Ajuda",
  here: "aqui",
  hideOnlineMenu: "Ocultar no menu online",
  highDenominations: "Altas Denominações",
  hostname: "Nome do host",
  hourly: "De hora em hora",
  idType: "Tipo de identificação",
  ifYouHaveAPreviousVersionOfApp: "Se você tiver uma versão anterior do aplicativo, exclua o aplicativo antes de atualizar",
  ignore: "Ignorar",
  ignoreAllOpenShifts: "Ignorar todos os turnos abertos",
  ignoreAllShifts: "Ignorar todos os turnos",
  ignoredShiftFromPrevious: "Mudança ignorada do EOD anterior",
  impItem: "Importação de itens",
  impItemMaxSize: "Tamanho máximo 25 MB",
  impItemModalNote1: "Para Item de Estoque/Item já existente em estoque, a importação aumentará a quantidade desse item de estoque em estoque",
  impItemModalNote2: "Para Item de Estoque/Item não existente no estoque, clique em confirmar para gerar novo SKU no estoque",
  impItemsErr1: "O local {0} não pode ser encontrado",
  impItemsErr2: "Medição {0} não encontrada",
  impItemsErr3: "Folha {0} {1} formato de dados incorreto",
  impItemsErr4: "Há uma diferença no preço do item em estoque {0} + Medição {1}",
  impItemsErr5: "A planilha {0} não deve exceder 200 linhas",
  impItemsErr6: "Categoria não encontrada",
  impItemsErr7: "Há uma diferença de preço para o item {0} + Medição {1}",
  impItemsPlsRecheck: "Verifique novamente os dados na importação do arquivo e faça upload novamente",
  import: "Importar",
  importSupplyItems: "Importar itens de estoque",
  importSupplyItemsCreateWholeProducts: "Importe itens de estoque e crie itens inteiros",
  importSupplyItemsErr: "Os nomes dos locais não correspondem aos locais existentes no local. Verifique novamente",
  inHouse: "Interno",
  inputReason: "Motivo de entrada",
  installAPK: "Instalar APK",
  integration: "Integração",
  interval: "Intervalo",
  inventoryExisted: "Inventário existente",
  inventoryGroup: "Grupo de inventário",
  inviteResponse: "Convidar resposta",
  inviteYourStaff: "Convide sua equipe",
  invoice: "Fatura",
  invoiced: "Faturado",
  invoiceDate: "Data da fatura",
  invoicedInSiigo: "Faturado em Siigo",
  invoiceNumber: "Nº da fatura",
  invoices: "Faturas",
  invoiceType: "Tipo de fatura",
  isDefault: "É padrão",
  isDefaultPaymentGateway: "Gateway de pagamento padrão",
  issueDate: "Data de emissão",
  itemBargain: "O preço deste item foi alterado de {0} para {1}",
  itemImport: "Importação de itens",
  justNow: "Agora mesmo",
  learnHowToRenewSubscription: "Saiba como renovar sua assinatura",
  linkOutlet: "Localização do link",
  linkOutletHoverTooltip: "Link para locais do MEWS",
  litePlanMaxProductReached: "Você atingiu o número máximo de itens {0} com seu plano {1}.",
  litePlanMaxStaffReached: "Você atingiu o número máximo de funcionários {0} com seu plano {1}.",
  locateAPK: "Localizar APK",
  locateAPKDesc: "Abra o gerenciador de arquivos do seu dispositivo e encontre o APK na pasta “Downloads”.",
  locationQRCode: "Código QR de localização (um para todo o local)",
  lowDenominations: "Denominações baixas",
  male: "Macho",
  mainGuestTag: "Principal",
  manageLocationTable: "Gerencie a disposição das mesas e assentos deste local.",
  manageOfPermissionToEnterSpecificAreas: "Gerenciar permissão para entrar em áreas específicas",
  managerRoleDesc: "Acesso total ao site e aplicativo on-line.",
  manageTipDesc: "Ative a gorjeta e defina a porcentagem da gorjeta que você gostaria de exibir no PDV",
  manageVenues: "Gerenciar locais",
  manuallyDownloadUpdateSocashlessApp: "Baixe/atualize manualmente o aplicativo SoCashless na Google Play Store:",
  mapToSiigo: "Mapa para Siigo",
  maxProductReached: "Máximo de item alcançado",
  maxStaffReached: "Máximo de pessoal alcançado",
  measurement: "Medição",
  mediumDenominations: "Denominações médias",
  menuEngineering: "Engenharia de cardápio",
  merchantId: "ID do comerciante",
  merchantSecret: "Chave secreta",
  merchantUrl: "URL do comerciante",
  mews: "MEWS",
  mewsAccounting: "MEWS_Contabilidade",
  mewsAccounting1: "Contabilidade MEWS",
  mewsBookings: "MEWS_Reservas",
  mewsBookings1: "Reservas MEWS",
  mewsSystems: "Sistemas MEWS",
  mewsTaxCode: "O código tributário é do MEWS?",
  mewsTaxCodeEditNote: "Nota: Quando as transações forem sincronizadas, os itens vinculados a este imposto terão valor de IVA em MEWS.",
  missingTransactionsDetected: "Transações ausentes detectadas",
  mode: "Modo",
  monthly: "Mensal",
  multiProperty: "Multipropriedade",
  na: "N / D",
  newQty: "Nova quantidade",
  newSku: "Novo SKU",
  nfcStatus: "Estado NFC",
  nfcTags: "Etiquetas NFC",
  night: "noite",
  noAvailableAccessPoint: "Nenhum ponto de acesso disponível",
  noDashboardAccess: "No momento, você não tem acesso ao painel.",
  noDataAvailable: "Não há dados disponíveis",
  none: "Nenhum",
  noOfCheckedIn: "{0} fez check-in",
  noOfCheckedOut: "{0} finalizado",
  noOfTables: "Nº de tabelas",
  noRecords: "Sem registros.",
  noSearchFound: "Nenhuma pesquisa encontrada",
  noShow: "Não comparecimento",
  noTagYet: "Nenhuma etiqueta ainda",
  notesAndGuideline: "Notas e Diretrizes",
  noteUpdateLastVersion: "Nota: Este “Pop Up” continuará sendo exibido até que todos os seus dispositivos ativos sejam atualizados para a versão mais recente. Verifique a versão do aplicativo dos seus dispositivos,",
  nowToDo: "agora para fazer",
  oldGuestId: "ID de convidado antigo",
  onboardingDescription: "Configure seu local com estas etapas simples para começar.",
  onboardingDescriptionCompleted: "Incrível! Agora você pode começar a vender em seus dispositivos POS SoCashlessVENUE! Encomende suas etiquetas NFC agora para fazer transações sem dinheiro com ativação de fechadura de porta! Confira também nosso e-book sobre como otimizar seu local!",
  onboardingTitle: "Bem-vindo! Comece a configurar seu local.",
  onboardingTitleCompleted: "Seu local está pronto para funcionar!",
  onceYoureOnTheAppsPage: "Quando estiver na página do aplicativo:",
  onceYoureOnTheAppsPageDesc: "Clique no botão “Instalar”/“Atualizar”\n(Para atualizar o aplicativo, a Google Play Store verificará automaticamente se há atualizações e solicitará que você atualize, se necessário.)",
  onlineMenuOnly: "Apenas menu on-line",
  onlyDateRangesLessThanOneYear: "Somente períodos inferiores a um ano são aceitos",
  opened: "Aberto",
  orderQuantityRequired: "A quantidade do pedido é necessária",
  orderYour: "Encomende o seu",
  orderYourNFCTags: "Encomende suas tags NFC",
  outlet: "Localização",
  pasteUrlInDeviceBrowserAndDownload: "Cole o URL no navegador do seu dispositivo e baixe o APK ou siga o link do código QR para baixar o APK.",
  paymentGatewayDeleted: "Gateway de pagamento \"{0}\" excluído.",
  paymentGatewayName: "Nome do gateway de pagamento",
  paymentGatewayUpdated: "Gateway de pagamento \"{0}\" atualizado.",
  paymentMethodInSiigo: "Método de pagamento em Siigo",
  payments: "Pagamentos",
  paymentsListSettings: "Configurações da lista de gateways de pagamento",
  paymentsSettings: "Configurações de pagamento",
  paymentTerms: "Condições de pagamento:",
  pending: "Pendente",
  phoneNo: "Número de contato",
  pleaseChooseLocation: "Por favor escolha o local",
  pleaseContactOwnerToReactiveVenue: "Entre em contato com o proprietário do local para renovar a assinatura e reativar este local.",
  pleaseContactSupportRenewSubscription: "Entre em contato com o suporte para renovar sua assinatura e reativar seu local.",
  pleaseCopyUrl: "Copie o URL abaixo e cole em seu navegador ou escaneie o código QR:",
  pleaseCopyUrlApk: "Se o seu dispositivo não tiver a Google Play Store, baixe o aplicativo no URL abaixo ou escaneie o código QR com o dispositivo:",
  pleaseCreateAccounts: "Crie códigos de conta a partir da sua plataforma de contabilidade integrada.",
  pleaseEmailUs: "Envie um e-mail para {0} {1}",
  pleaseEnterYourSFTP: "Insira os detalhes e credenciais do seu servidor SFTP.",
  pleaseFetchDataFromSiigoByClickingButtonBelow: "Obtenha dados do Siigo clicando no botão abaixo",
  pleaseMakeSureToSyncAllDataBeforeDeleteApp: "Certifique-se de sincronizar todos os dados antes de excluir o aplicativo.",
  pleaseReadThisInstructionCarefully: "Por favor leia esta instrução com atenção",
  pleaseRenewSubscription: "Por favor, renove sua assinatura para reativar seu local.",
  pleaseUpgradeToUseLockedFeature: "Atualize seu plano para usar este recurso bloqueado.",
  posAndOnlineMenu: "PDV + Menu Online",
  posOnly: "Somente PDV",
  socashlessPaymentMethod: "Método de pagamento sem dinheiro",
  socashlessTax: "Imposto sem dinheiro",
  socashlessPay: "EntãoCashlessPAY",
  preloadedCredit: "Crédito pré-carregado",
  prepareImport: "Preparando a importação",
  productCodeInSiigo: "Código do item no Siigo",
  productForTips: "Item para dicas",
  productSettings: "Configurações de itens",
  productsWithNoCategory: "Estes são itens sem categorias ainda",
  propertyManagementSystemExample: "Sistemas como MEWS e Cloudbeds",
  purchasePlus: "Compra Plus",
  purchaseplus: "Compre mais",
  qrCodeForOnlineMenu: "Código QR para Menu Online",
  quarter: "Trimestre",
  quarterly: "Trimestral",
  readyForDownload: "pronto para download",
  referenceNo: "Ref. Não.",
  registeredBusinessInformation: "Informações comerciais registradas",
  registeredBusinessTaxNumber: "Número fiscal comercial registrado",
  registeredOfficialBusinessName: "Nome comercial registrado/oficial",
  registerGuestsRoleAppDesc: "Esta função não tem acesso ao site.",
  registerGuestsRoleDashboardDesc: "Permite acesso aos convidados de Check-in e Check-out do App.",
  regulateEntryExit: "Regular entrada/saída",
  regulateEntryExitDesc: "A ativação desta funcionalidade permite uma regulação precisa de entrada e saída no ponto de acesso.\nQuando desativado, o controle de acesso permanece funcional, mas não diferenciará entre entradas e saídas.",
  removeSku: "SKU removido",
  removeStaff: "Remover funcionários?",
  renewSubscription: "Renovar assinatura",
  report: "Relatório",
  reportAProblem: "Informar um problema",
  reportingDay: "Dia do Relatório",
  requireManagerAuthorizationVoucher: "Exigir autorização do gerente ao emitir este voucher.",
  resync: "Sincronizar novamente",
  resyncEInvoice: "Sincronizar novamente a fatura eletrônica",
  resyncSuccessfully: "Sincronize novamente com sucesso",
  returnCreditsRoleAppDesc: "Esta função não tem acesso ao Painel do Local on-line.",
  returnCreditsRoleDashboardDesc: "Permite acesso aos créditos de devolução do Venue App",
  revenueAccountMessage: "A conta padrão para todas as receitas de vendas.",
  running: "Correndo",
  runningTheEodWithUnsynced: "A execução do EOD com transações não sincronizadas resultará em um relatório incompleto.",
  salesFOC: "FOC de vendas",
  salesFOCMessage: "O custo de todos os créditos gratuitos aplicados.",
  salesOverTime: "Vendas ao longo do tempo",
  salesSummary: "Resumo de vendas",
  salesTax: "Imposto sobre vendas",
  scanningTheQRcode: "Digitalizando o código QR",
  scanningTheQRcodeDesc: "Abra o aplicativo da câmera do seu dispositivo e aponte a câmera para o código QR fornecido. Isso abrirá automaticamente um link para a página do aplicativo na Google Play Store.",
  scanningTheQRcodeOrUsingUrl: "Digitalizando o código QR ou usando o URL",
  scanQRcode: "Digitalize o código QR",
  scheduleACall: "Agende uma chamada",
  searchCategories: "Pesquise e selecione categorias para este voucher",
  searchEInvoicePlaceholder: "Pesquise fatura eletrônica por Siigo Inv No., Nome do Convidado ou Número CUEF",
  searchGuestsBalanceMovements: "Pesquise convidados por nome ou ID de tag",
  searchPaymentGateway: "Pesquise por nome do gateway de pagamento",
  searchStaffEmailOrTagID: "Pesquisar e-mail da equipe ou ID da tag",
  seeError: "Ver erro",
  selectAccessPoints: "Selecione pontos de acesso",
  selectCharge: "Selecione Cobrar",
  selectInventoryGroup: "Selecione o grupo de inventário",
  selectInventoryGroupFormSiigoToAssign: "Selecione um grupo de inventário do Siigo para atribuir a este item",
  selectInvoiceType: "Selecione o tipo de fatura",
  selectNumberOfTables: "Selecione o número de tabelas",
  selectOutlet: "Selecione o local",
  selectProductForTips: "Selecione o item para dicas",
  selectRedeemableProducts: "Selecione itens resgatáveis",
  selectSeller: "Selecione o vendedor",
  selectSource: "Selecione a fonte",
  seller: "Vendedor",
  sellingQtyMustBeGreaterThanZero: "A quantidade de venda deve ser maior que zero.",
  sellOnPosRoleAppDesc: "Esta função não tem acesso ao site.",
  sellOnPosRoleDashboardDesc: "Permitir acesso à venda de PDV do aplicativo",
  sendTo: "Enviar para",
  sendToDian: "Enviar para Dian",
  sendToDianSuccessfully: "Enviar para Dian com sucesso",
  sendToSiigo: "Enviar para Siigo",
  sendToSiigoSuccessfully: "Enviar para Siigo com sucesso",
  setDefaultPaymentGateway: "Definir gateway de pagamento padrão",
  setupYourPaymentGateways: "Configure seus gateways de pagamento",
  shiftAlreadyClosed: "Este turno já está fechado.",
  shiftClosed: "Turno Fechado",
  shiftsAndTransactions: "Turnos e Transações",
  showErrorInvoiceOnly: "Mostrar apenas fatura com erro",
  showNumOutDateDevices: "Nosso sistema mostra que apenas os dispositivos {0} foram atualizados para a versão mais recente. Atualize os dispositivos restantes para a versão mais recente.",
  showOnlineMenu: "Mostrar no menu on-line",
  siigo: "Siigo",
  siigoAccount: "Conta Siigo",
  siigoAccountConnectedToDian: "Conta Siigo conectada a Dian",
  siigoDescBill: "É necessário que o tipo de desconto esteja configurado como ‘Porcentagem’ e que esteja ativo no Siigo.",
  siigoDescInventoryGroup: "No Siigo, um grupo de inventário é usado para organizar e categorizar itens semelhantes. Se um item no local não tiver um grupo de inventário específico atribuído, ele será automaticamente colocado no Grupo de inventário padrão.",
  siigoDescPaymentMethod: "Digite o nome do item ou serviço ao qual suas dicas serão associadas. Este item será criado (ou atualizado, caso já exista) no Siigo e mapeado com dicas no local para fins de faturamento.",
  siigoDescProductForTips: "O item que será usado para faturar as gorjetas que você receber",
  siigoDescSalesTax: "Vincule o imposto no SoCashless aos impostos correspondentes no Siigo. Se você não selecionar um imposto no Siigo, as faturas que incluem o imposto não serão criadas.",
  siigoDescSeller: "Este vendedor será o vendedor da fatura criada no Siigo",
  siigoError: "Erro Siigo",
  siigoIntegrationDetail: "Detalhe de integração Siigo",
  siigoInvNo: "Siigo Inv No.",
  siigoInvoiceNumber: "Número da fatura Siigo:",
  someShiftsHaveUnsynced: "Alguns turnos têm transações não sincronizadas. Por favor, verifique os dispositivos dos turnos para enviar os dados do local.",
  somethingWentWrongPlsTryAgain: "Algo deu errado. Por favor, tente novamente",
  sorryVenueSuspended: "Desculpe, este local foi suspenso.",
  source: "Fonte",
  sourceLocation: "Local de origem",
  sourceLocationOriginalQty: "Quantidade original do local de origem",
  sourceLocationRemainQty: "O local de origem permanece em quantidade",
  sourceLocationTransferQty: "Quantidade de transferência de local de origem",
  specificCategories: "Categorias Específicas",
  specificProducts: "Itens Específicos",
  state: "Estado",
  step: "Etapa",
  stockAdjSupplyItemsTxtConfirm: "Tem certeza de que deseja ajustar o estoque para itens em estoque em {0}",
  stockAdjustment: "Ajuste de estoque",
  stockLevel: "Nível de estoque",
  stockManagerRoleAppDesc: "Esta função não tem funções relacionadas ao aplicativo e não seria capaz de fazer login no dispositivo.",
  stockManagerRoleDashboardDesc: "Permite acesso ao Painel do Local que é limitado apenas ao Estoque do Inventário.",
  subscription_only_owner_access: "Somente o proprietário do local que assinou este plano pode acessar esta assinatura",
  subscriptionCanceledReason: "Você cancelou sua assinatura.",
  subscriptionExpiredReason: "Você cancelou sua assinatura.",
  subscriptionSuspended: "A assinatura terminou. Entre em contato com o proprietário do local para renovar a assinatura antes de {1} para manter o acesso a {2}.",
  subscriptionSuspendedIn5: "Este local está prestes a ser suspenso em 5 dias. Entre em contato com o proprietário do local para renovar a assinatura antes de {0} para manter o acesso a {1}.",
  subscriptionSuspendedIn5Manager: "Seu local será suspenso em menos de 5 dias. Renove sua assinatura antes de {0} para manter o acesso a {1}.",
  subscriptionSuspendedManager: "{0} Renove sua assinatura antes de {1} para manter o acesso a {2}.",
  subscriptionSuspendedToday: "Seu local será suspenso hoje. Entre em contato com o proprietário do local para renovar a assinatura e manter o acesso a {0}.",
  subscriptionSuspendedTodayManager: "Seu local será suspenso hoje. Renove sua assinatura hoje para manter o acesso a {0}.",
  subscriptionUnpaidReason: "Parece haver um problema com seus detalhes de pagamento.",
  supplyTaxes: "Impostos sobre fornecimento",
  supplyValue: "Valor da oferta",
  supportSocashless: "support@socashless.com",
  suspended: "Suspenso",
  syncFromSiigo: "Sincronizar do Siigo",
  syncFromSiigoDesc: "Se você adicionar ou atualizar suas informações no Siigo (tipo de fatura, vendedor, grupo de estoque, forma de pagamento ou imposto), será necessário sincronizá-las novamente para mapear com seu equivalente no SoCashless.",
  syncFromSiigoSuccessfully: "Sincronize do Siigo com sucesso",
  syncToDian: "Sincronizar com Dian",
  tableManagement: "Gerenciamento de Tabela",
  tableQRCode: "Códigos QR de tabela (por tabela)",
  tables: "Tabelas",
  tapOnTheAPKFileToStartTheInstallationProcess: "Toque no arquivo APK para iniciar o processo de instalação. Siga as instruções na tela para concluir a instalação. Depois de instalado, abra o aplicativo na gaveta de aplicativos ou na tela inicial.",
  taxCode: "Código Tributário",
  taxInvoiceNo: "Nota Fiscal#:",
  taxInvoiceNumber: "Número da Nota Fiscal",
  termsInAllowingAccess2: "Ao clicar em Permitir acesso, você autoriza {0} a usar, receber e armazenar suas informações. Você pode interrompê-lo a qualquer momento nas configurações de integrações da sua conta SoCashless.",
  termsInAllowingAccess3: "Ao clicar em Permitir acesso, você autoriza {0} a armazenar suas informações de {1}. Revise nossos {2} e {3}.",
  siigoSendInvoiceError: "Erro ao enviar a fatura. Clique no número da fatura relevante para obter mais informações.",
  theActualNumberOfGuests: "O número real de hóspedes que fizeram check-in/out",
  theAmountTheGuestWillPay: "Este é o valor que o hóspede pagará pela reserva.",
  theBookingStatus: "O status da reserva da origem.",
  theGuestHasNoAssignedRoom: "O hóspede não tem quarto atribuído!",
  theLastVersion: "Versão mais recente do aplicativo:",
  theLastVersionOfAppAvailable: "A versão mais recente do aplicativo {0} já está disponível na Google Play Store.",
  theseNthOtherProducts: "{0} {1} outros itens com este local e outros locais permanecerão em seu inventário.",
  theUpdateShouldBeAppliedAutomatically: "A atualização deve ser aplicada automaticamente, mas você também pode abrir o link abaixo ou escanear o código QR para baixar a versão mais recente do aplicativo.",
  thisGuestHasNotCheckedOutYet: "Este hóspede ainda não fez check-out",
  thisIsForDirectIntegrationWithPaymentTerminalPartner: "Isto é para integração direta com Parceiro Terminal de Pagamento",
  thisLocationHasTables: "Este local possui mesas e assentos.",
  thisShiftHasUnsyncedTransactions: "Esta mudança tem transações não sincronizadas",
  thisUrlIsInvalid: "Este URL é inválido.",
  ticketing: "Ticketing",
  ticketNo: "Bilhete Não",
  timeout: "Tempo esgotado",
  tip: "Dica",
  tipOptions: "Opções de dicas",
  tipReport: "Relatório de dicas",
  tips: "Pontas",
  tipsAndCharges: "Dicas e cobranças",
  topupCreditsRoleAppDesc: "Esta função não tem acesso ao site.",
  topupCreditsRoleDashboardDesc: "Permitir acesso à recarga do aplicativo",
  toScheduleACall: "Para agendar uma ligação com nosso suporte ao cliente.",
  totalCreditsKept: "Total de créditos mantidos (após checkout)",
  totalCreditsKeptByGuests: "Total de créditos mantidos pelos hóspedes",
  totalCreditsKeptTooltip: "Quantidade total de créditos que os hóspedes mantiveram após o check-out",
  totalCreditsReceived: "Total de créditos recebidos",
  totalCreditsReceivedFromVenues: "Total de créditos recebidos de outros locais",
  totalCreditsReceivedTooltip: "Quantidade total de créditos recebidos dos hóspedes que fizeram check-in com créditos retidos de outros locais",
  totalExpectedEndingBalance: "Saldo final total esperado",
  totalItems: "Total de itens",
  totalOpeningBalance: "Saldo inicial total",
  totalRefunded: "Total Reembolsado",
  totalUnspentCredits: "Total de créditos não gastos",
  totalUnspentCreditsDesc: "Soma de todos os créditos não gastos de hóspedes vinculados a {0} e com check-out agendado entre as datas do seu filtro acima.",
  toViewDetailedInstructions: "Para visualizar instruções detalhadas",
  tradeTypeTransactionNumber: "{0} Trans Não",
  transfer: "Transferir",
  transferSupplyItems: "Transferir itens de estoque",
  transferSupplyItemsSuccessfully: "Transferir itens de estoque com sucesso",
  transferSupplyItemsTxtConfirm: "Tem certeza de que deseja transferir itens de estoque de {0} para {1}?",
  unbill: "Desfaturar",
  undefinedError: "Erro indefinido",
  undefinedErrorPlsTryAgain: "Erro indefinido. Atualize a página e tente novamente",
  unignore: "Designorar",
  unignoreAllOpenShifts: "Designorar todos os turnos abertos",
  unignoreAllShifts: "Designorar todos os turnos",
  unitPrice: "Preço unitário",
  updatedVersionOfTheAppIsNowAvailable: "A versão atualizada do aplicativo já está disponível!",
  upgradeNow: "Atualize agora",
  upgradePlanHeader: "Turbine seu local e acesse mais recursos premium ao atualizar seu plano agora!",
  upgradeYourPlan: "Atualize seu plano! ✨",
  upload: "Carregar",
  uploadExcelFileToImport: "Carregar arquivo Excel para importar",
  upToDate: "Atualizado",
  user: "Usuário",
  username: "Nome de usuário",
  useThisVenueDetails: "Use os detalhes deste local",
  usingTheURL: "Usando o URL",
  usingTheURLdesc: "Abra seu navegador e cole o URL fornecido na barra de endereço e pressione Enter e isso o levará à página do aplicativo na Google Play Store.",
  venue: "Local",
  venueInformation: "Informações sobre o local",
  venueInLitePlan: "Este local está atualmente no Plano Lite.",
  venueLogo: "Logotipo do local",
  venueMode: "Modo Local",
  venueSuspended: "Local suspenso",
  veryHighDenominations: "Denominações muito altas",
  viewAccountOnSiigo: "Ver conta no Siigo",
  viewAndExportFreeCreditsReport: "Visualize e exporte créditos gratuitos emitidos e removidos.",
  viewBy: "Ver por",
  viewInfo: "Ver informações",
  viewInvoice: "Ver fatura",
  viewListInvoiceTitle: "Veja a lista de faturas para convidados com check-out em seu local",
  viewPaymentGateway: "Ver gateway de pagamento",
  viewPrinter: "Ver impressora",
  voucherIssue: "Emissão de voucher",
  voucherReachedIssuanceLimit: "Este voucher atingiu o limite máximo de emissão de {0}.",
  voucherRemove: "Remover comprovante",
  warning: "Aviso",
  warningResyncDesc: "Ainda há transações faltando no sistema de fatura eletrônica devido a dispositivos off-line.\nPor favor, certifique-se de que todos os dispositivos do local estejam conectados à Internet e tenham seus dados enviados para o sistema para completar a sincronização e, em seguida, clique no botão “Re-sincronizar E-Invoice” para atualizar a fatura.",
  warningSiigoIntegrationDesc: "Para cumprir os regulamentos da Dian, é obrigatória a coleta das seguintes informações dos hóspedes: nome, e-mail, tipo de identificação e ID.\nAo integrar com o Siigo, essas perguntas aparecerão automaticamente nos perfis dos hóspedes.\n\nPor favor, não as desmarque para garantir que coletamos todos os dados necessários durante o check-in. Não seremos responsáveis ​​por qualquer informação faltante devido ao não cumprimento.\n\n",
  weekMon2Sun: "Semanalmente (Seg a Dom)",
  weekSun2Sat: "Semanalmente (dom a sábado)",
  whatAreFreePostpaidCredits: "O que são créditos gratuitos e créditos pós-pagos?",
  wouldReadOrWrite: "{0} leria e/ou escreveria as seguintes informações:",
  yesterday: "Ontem",
  youCanReviewQuestionInEachGuestProfile: "Você pode revisar a pergunta em cada perfil de convidado",
  yourSubscriptionCanceled: "Sua assinatura do plano {0} para seu local, {1, foi cancelada.",
  yourSubscriptionEnded: "Sua assinatura do plano {0} para seu local, {1, terminou.",
  siigoCardDesc: "Siigo é um software avançado de contabilidade online com ferramentas de faturamento compatíveis com Dian, essencial para otimizar a eficiência e impulsionar o crescimento dos negócios",
  youAreCurrentlyInSiigoEnv: "Você está habilitando o ambiente Siggo para este local. Observe que esta configuração não oferece suporte ao recurso 'Custos adicionais'.",
  youAreEnablingSiigo: "Você está habilitando o ambiente Siggo para este local. Observe que o recurso 'Taxas Adicionais' não é compatível com esta configuração.",
  setToDefault: "Definir como padrão",
  registerForRefund: "Registre-se para reembolso",
  refund: "Reembolso",
  onGroundReport: "Resumo de registro e acesso de reserva",
  multipleInReport: "Acesso múltiplo em",
  guestProfileId: "ID do perfil do convidado",
  totalSold: "Total vendido",
  totalActivated: "Total ativado",
  activePercentage: "% ativo",
  totalAccessIn: "Acesso total em",
  accessedPercentage: "% acessado",
  notActivated: "Não ativado",
  notActivatedPercentage: "% não ativado",
  notAccessed: "Não acessado",
  notAccessedPercentage: "% não acessado",
  onGround: "Relatório no terreno",
  inactiveBookingReport: "Resumo de reservas inativas",
  transactionRefundReport: "Reembolsos totais",
  topupAndSaleSummaryReport: "Resumo de recarga e venda",
  remainingBalanceReport: "Saldo restante da carteira",
  duplicateTicketsReport: "Relatório de tickets duplicados",
  enableKiosk: "Habilitar quiosque",
  connectSiigoToYourSocashlessAccount: "Conecte {0} à sua conta SoCashless.",
  totalDistinctWalletsUsedForTransactions: "Total de carteiras distintas usadas para transações",
  countOfWalletWithCashRemaining: "Contagem de carteira com dinheiro restante",
  version: "Versão",
  totalCheckIn: "Check-in total",
  totalTopUp: "Recarga total",
  transactionLastSynced: "Última transação sincronizada",
  deviceSyncStatus: "Status de sincronização do dispositivo",
  ticketType: "Tipo de ingresso",
  topUpAndSalesSummaryReport: "Resumo de recarga e vendas",
  totalRefundReport: "Reembolso total",
  yourMightGetNegative: "O relatório solicitado destina-se ao modo Eventos enquanto você estiver no modo Locais.",
  maximumTopUp: "Recarga máxima",
  mdr: "MDR",
  guestRefundReport: "Relatório de reembolso de hóspedes",
  guestRefundReportDesc: "Gerencia dados de reembolso de convidados para eventos",
  tagUid: "ID da interface do usuário da etiqueta",
  tagBalance: "Equilíbrio",
  eventStartDateTime: "Data de início e término do evento",
  event: "Evento",
  transactionStartDateTime: "Data de início e término da transação",
  refundStartDateTime: "Data de início e término do reembolso",
  mdrCharges: "Encargos MDR",
  amountClaimed: "Valor reivindicado",
  claimDate: "Data da reivindicação",
  claimStatus: "Status da reivindicação",
  refundClaimReport: "Relatório de reivindicação de reembolso",
  refundClaimReportDesc: "Gerencia dados de solicitação de reembolso de convidados para eventos",
  refunded: "Reembolsado",
  registered: "REGISTRADO",
  exported: "Exportado",
  kiosk: "Quiosque",
  minimumTopUp: "Recarga mínima",
  deviceLocation: "Localização do dispositivo",
  connectToSiigo: "Conecte-se ao Siigo",
  connectToSiigoDesc: "Para usar a implementação do Siggo, entre em contato com nossa equipe de administração para obter acesso.",
  totalDiscount: "Desconto total",
  eventTimeZone: "Fuso horário do evento",
  taxPercentage: "% de imposto",
  searchByGuestNameEmailTagUid: "Pesquise por nome do convidado, e-mail/telefone, tag UID",
  amountRecieved: "Valor recebido",
  gHL: "GHL",
  pendingUnbill: "Sincronização de transação não faturada pendente",
  cancelationReport: "Relatório de cancelamento",
  cancelationReportDesc: "Veja a lista de ingressos cancelados.",
  cancelTicket: "Cancelar ingresso",
  ticketDetails: "Detalhes do ingresso",
  ticketCancelled: "Bilhete cancelado",
  timeZone: "Fuso horário",
  isAppliedForStaff: "Aplicado para funcionários",
  voucherId: "ID do voucher",
  customerName: "Nome do cliente",
  voucherTransaction: "Transação de voucher",
  topupVoucher: "Voucher de recarga",
  refundVoucher: "Voucher de reembolso",
  voucherDate: "Data do voucher",
  guestTagUid: "UID da etiqueta de convidado",
  tagUseCount: "Contagem de uso de tags",
  model: "Modelo",
  osVersion: "Versão do sistema operacional",
  firmwareVersion: "Versão do Firmware",
  softwareVersion: "Versão do software",
  ghlVersion: "Versão do aplicativo GHL",
  ttbVersion: "Versão do aplicativo TTB",
  userDetails: "Detalhes do usuário logado",
  deviceRegisterDateTime: "Data e hora de registro do dispositivo",
  deviceLastLocationDateTime: "Data e hora da última atualização do local",
  mdmDeviceList: "Lista de dispositivos MDM",
  mdmDeviceListDescription: "Visualize e gerencie informações do dispositivo MDM",
  mdm: "MDM",
  deviceGeoLocation: "Localização geográfica do dispositivo",
  deviceGeoLocationDescription: "Veja a localização dos dispositivos em um mapa interativo",
  deviceLocationMap: "Mapa de localização do dispositivo",
  selectDeviceLocation: "Selecione a localização do dispositivo",
  showingDevicesOnMap: "Mostrando dispositivos no mapa",
  searchMdmDevices: "Pesquisar dispositivos MDM...",
  resyncVoucher: "Voucher de ressincronização",
  topup: "Recarregar",
  unsyncTransactionReports: "Relatório de saúde da TPM",
  count: "Contar",
  monthlySaleReport: "Relatório mensal de vendas",
  subscriptionPlanName: "Plano de assinatura",
  subscriptionCustomerId: "ID do cliente",
  allowNonNfcActivationProfile: "Permitir ativação não NFC para este perfil de convidado",
  nonNfcActivation: "Ativação sem NFC",
  adjustment: "Ajuste",
  adjustmentVoucher: "Voucher de ajuste",
  importFile: "Arquivo de importação (.xlsx)",
  importFail: "Falha na importação!",
  fileSizeExceeded: "O tamanho do arquivo excede o limite permitido de {0}. Divida os dados em dois arquivos e use o recurso de upload incremental para continuar.",
  invalidBookingFileType: "Formato de arquivo inválido. Somente arquivos {0} são suportados para importação. Faça upload de um arquivo {1} válido e tente novamente.",
  selectImportType: "Selecione o tipo de importação",
  selectImportTypeDesc: "Você está realizando uma importação incremental ou nova?",
  incremental: "Incremental",
  newBookingDataImport: "{0} os registros de dados existentes serão excluídos e {1} novos registros de dados serão carregados. Você ainda quer continuar?",
  topUpType: "Recarregar",
  refundType: "Reembolso",
  documentType: "Tipo de documento",
  selectTopupType: "Selecione o tipo de recarga",
  selectRefundType: "Selecione o tipo de reembolso",
  outletName: "Nome do local",
  createOutlet: "Criar local",
  editOutlet: "Editar local",
  deleteOutlet: "Excluir local",
  topupAccount: "Recarregar",
  refundAccount: "Reembolso",
  invoiceAccount: "Fatura",
  arrivalTime: "Hora de chegada",
  arrivalTimeReport: "Relatório de horas de chegada",
  arrivalTimeStatisticView: "Visão estatística de horas de chegada",
  arrivalTimeStatisticViewDesc: "Acompanhe as chegadas previstas de convidados e o preenchimento do formulário por hora de chegada.",
  guestsByArrivalTime: "Convidados por hora de chegada",
  arrivalTimeSummary: "Resumo de horas de chegada",
  guestRegistration: "Registro de convidados",
  registeredGuests: "Convidados registrados",
  totalGuests: "Total de convidados",
  guestCount: "Número de convidados",
  peakHour: "Horário de pico",
  noArrivalTimeData: "Nenhuma chegada encontrada para esta data.",
  bothGuestTypes: "Ambos",
  filter: "Filtrar",
  clearAll: "Limpar tudo",
  apply: "Aplicar",
  pickADate: "Escolha uma data",
  last7Days: "Últimos 7 dias",
  last30Days: "Últimos 30 dias",
  last90Days: "Últimos 90 dias",
  customRange: "Intervalo personalizado",
  totalReservedGuests: "Total de convidados reservados",
  totalPreCheckinGuests: "Total de convidados com pré-check-in",
  waitForPreCheckinGuests: "Convidados aguardando pré-check-in",
  zeusDescription: "Gestão hoteleira criada para acomodações sociais de alto volume.",
  reservationCode: "Código da reserva",
  reservationDetails: "Detalhes da Reserva",
  reservationNo: "Núm. Reserva",
  reservationSummary: "Sumário da Reserva",
  formCompletion: "Formulários preenchidos",
  manifestPublicLink: "Link público do manifesto",
  identificationType: "Tipo de identificação",
  idNumber: "Número de identificação",
  idScan: "Digitalização do documento",
  medicalCondition: "Condição médica",
  foodAllergies: "Alergias alimentares",
  specialNotes: "Notas especiais",
  freeCredit: "Crédito gratuito",
  guestNumber: "Convidado {0}",
  seatsForZone: "{0} lugares para {1}",
  seatsQuantity: "{0} lugares",
  clickHereLink: "Clique aqui",
  zone: "Zona",
  ticket: "Ingresso",
  passport: "Passaporte",
  nationalIdentificationCard: "Cartão de identificação nacional",
  drivingLicense: "Carta de condução",
  package: "Pacote",
  reservationOriginalFreeCredit: "Crédito gratuito original da reserva",
};

export default Object.freeze(locale);
